import Cookies from 'js-cookie';
import i18n from '../../i18n';
import Config from './Config';
import Utils from './../Utils';

var currentLanguage = Cookies.get('currentLanguage');
var smallCurrentLanguage = i18n.language;
smallCurrentLanguage = smallCurrentLanguage.toLowerCase();

var urls = {
    en: `${Config.storage}samples/reports/en.zip`,
    es: `${Config.storage}samples/reports/es.zip`,
    pt: `${Config.storage}samples/reports/pt.zip`,
    'pt-br': `${Config.storage}samples/reports/pt-br.zip`,
};

var url = urls['en'];

if (Utils.isset(urls[`${currentLanguage}`])) {
    url = urls[`${currentLanguage}`];
}

var DataArray = {
    details: [
        {
            text: i18n.t('14-day free trial'),
        },
        {
            text: i18n.t('Cancel anytime'),
        },
    ],
    andieDetails: [
        {
            text: i18n.t('14-day free trial'),
        },
        {
            text: i18n.t('No credit card required'),
        },
        {
            text: i18n.t('Cancel anytime'),
        },
    ],
    brands: [
        {
            brand: require('./../../resources/icons/logos/famalicao.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/fitness_up.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/bphl.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/dst_group.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/solverde.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/one_clinics.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/ucatolica.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/creative_minds.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/back.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/kinda home.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/zyrgon.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/savoy.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/caetsu.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/luxhotels.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/pluricosmetica.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/estoril.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/caetano_auto.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/uaveiro.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/uip.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/dott.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/placard.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/silampos.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/eco.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/up.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/sana_hotels.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/leya.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/wemystic.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/fitness_factory.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/yves_rocher.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/fuel.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/lisobnawards.webp'),
        },
        {
            brand: require('./../../resources/icons/logos/shootfy.webp'),
        },
    ],
    typeClients: [
        {
            title: i18n.t('Agencies'),
            message: i18n.t(
                'Trusted everyday by thousands of Agencies to manage their clients on social media and to improve their results.\nFor agencies who are one step ahead.\n\nWhy do they use?'
            ),
            categories: [
                {
                    message: i18n.t(
                        'To schedule posts and share the content planning with the client;'
                    ),
                },
                {
                    message: i18n.t(
                        'To automate reports to be sent automatically to the client;'
                    ),
                },
                {
                    message: i18n.t(
                        'To understand and compare the results of their clients’ competitors;'
                    ),
                },
                {
                    message: i18n.t('To work with a team workflow.'),
                },
            ],
            image: require('./../../resources/images/typeClient/agencies.webp'),
            logos: [
                {
                    logo: require('./../../resources/icons/logos/vwlyr.webp'),
                },
                {
                    logo: require('./../../resources/icons/logos/alice.webp'),
                },
                {
                    logo: require('./../../resources/icons/logos/loba.webp'),
                },
                {
                    logo: require('./../../resources/icons/logos/hill_knowlton.webp'),
                },
            ],
        },
        {
            title: i18n.t('Publishers'),
            message: i18n.t(
                'Used by the main publishers to get tons of content shared easily and wisely.\n\n Why do they use?'
            ),
            categories: [
                {
                    message: i18n.t(
                        'To integrate with RSS Feed to automate multiple shares across social media channels;'
                    ),
                },
                {
                    message: i18n.t(
                        'To be alert about their competitors activity and to be notified about viral subjects;'
                    ),
                },
                {
                    message: i18n.t(
                        'To join different social media managers in differents shifts on the same workflow;'
                    ),
                },
                {
                    message: i18n.t(
                        'To get reports from thousands of posts in minutes.'
                    ),
                },
            ],
            image: require('./../../resources/images/typeClient/publishers.webp'),
            logos: [
                {
                    logo: require('./../../resources/icons/logos/sapo.webp'),
                },
                {
                    logo: require('./../../resources/icons/logos/mediacapital.webp'),
                },
                {
                    logo: require('./../../resources/icons/logos/publico.webp'),
                },
                {
                    logo: require('./../../resources/icons/logos/observadorLogo.webp'),
                },
            ],
        },
        {
            title: i18n.t('Brands & Businesses'),
            message: i18n.t(
                'The brands and businesses with a digital marketing strategy to grow on social media and that need to save time and to drive their resources to do the best work.\n\nWhy do they use?'
            ),
            categories: [
                {
                    message: i18n.t('To plan their content posts in one go;'),
                },
                {
                    message: i18n.t(
                        'To get reports about their activity and to understand their insights to readjust the strategy;'
                    ),
                },
                {
                    message: i18n.t(
                        'To build and get the best influencers for their business to do partnerships;'
                    ),
                },
                {
                    message: i18n.t(
                        'To compare the main KPI’s on social media with the competitors.'
                    ),
                },
            ],
            image: require('./../../resources/images/typeClient/brands.webp'),
            logos: [
                {
                    logo: require('./../../resources/icons/logos/engel.webp'),
                },
                {
                    logo: require('./../../resources/icons/logos/konica_minolta.webp'),
                },
                {
                    logo: require('./../../resources/icons/logos/activobank.webp'),
                },
            ],
        },
    ],
    categories: [
        {
            text: i18n.t('AI assistant'),
            href: 'andie',
            showOwnPage: true,
            navbarSpecial: true,
            image: require('./../../resources/images/category/andie_full.png'),
            navbarImage: require('./../../resources/images/category/andie_full_white.png'),
            icon: require('./../../resources/images/category/andie_full.png'),
            navbarButton: i18n.t('Read more about it'),
            navbarMessage: i18n.t(
                'ANDIE, your new Social Media Assistant, will tailor them to your brand\'s voice, industry, target audience, and much more.'
            ),
            message: i18n.t(
                'ANDIE, your new Social Media Assistant, will tailor them to your brand\'s voice, industry, target audience, and much more.'
            ),
            removeCategory: true,
            witness: {
                image: require('./../../resources/images/witness/listeningWitnessImage.webp'),
                logo: require('./../../resources/icons/witness/listeningWitnessLogo.webp'),
                name: i18n.t('Tiago Lopes,'),
                job: i18n.t('Social Media Editor & Community Manager'),
                message: i18n.t(
                    'Since I started working with Swonkie, the day-to-day work in different social networks has become very easy to plan. With a user-friendly interface and customer support that has always answered my questions, Swonkie is now an indispensable tool for managing our brands on various platforms.'
                ),
            },
            PageHome: {
                logos: [
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/brisa.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/macromakers.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/phb.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/sol.webp'),
                    },
                ],
                message: '',
            },
            content: [
                {
                    image: require('./../../resources/images/category/andie-image-1.png'),
                    imageSize: 'Small',
                    category: i18n.t('content generation'),
                    title: i18n.t('With ANDIE, you don’t need to know prompts'),
                    message: i18n.t(
                        'One of the difficulties of creating content with ChatGPT is knowing what to ask to get a good result – the so-called prompts. \n\n |With ANDIE, you don’t need to spend hours searching for the perfect prompt. Just fill out the form and your content will be optimized for your needs.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/record_voice_over.svg'),
                            title: i18n.t('Tone of Voice'),
                            message: i18n.t(
                                'In what tone of voice do you want the content: formal, friendly, other?'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/translate.svg'),
                            title: i18n.t('Language'),
                            message: i18n.t(
                                'Write content in Portuguese (PT-PT or PT-BR), English, Spanish or French.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/storefront.svg'),
                            title: i18n.t('Business Area'),
                            message: i18n.t(
                                'Add you business area so the content can be adapted to it.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/edit_note.svg'),
                            title: i18n.t('Writing Framework'),
                            message: i18n.t(
                                'Choose the copywriting framework you want to use to create the caption.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/topic.svg'),
                            title: i18n.t('Topics'),
                            message: i18n.t(
                                'Indicate up to 5 topics to be covered in the copy.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/match_word.svg'),
                            title: i18n.t('Keywords'),
                            message: i18n.t(
                                'Tell us which keywords to include in the copy.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/target.svg'),
                            title: i18n.t('Target Audience'),
                            message: i18n.t(
                                'Can you tell us a bit about the target audience for this publication?'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/public.svg'),
                            title: i18n.t('Social Network Opimization'),
                            message: i18n.t(
                                'Automatically optimize your copy for each social media.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/andie-image-2.png'),
                    imageSize: 'Small',
                    category: i18n.t('suggestions and improvements'),
                    title: i18n.t('Image suggestions for your publication'),
                    message: i18n.t(
                        'Have you tried asking ChatGPT for image suggestions? This is the response you get: “As an AI text-based model, I’m unable to directly browse the internet or provide specific image suggestions for a given article.” \n\n |ANDIE will suggest possible images that may fit your publication and, with 2 clicks, and the necessary adjustments, your publication is completely finished.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/add_photo_alternate.svg'),
                            title: i18n.t('Suggest images'),
                            message: i18n.t(
                                'Access and engage with your mentions to increase customer satisfaction and never miss one again.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/short_text.svg'),
                            title: i18n.t('Make longer or shorter'),
                            message: i18n.t(
                                'Manage all mentions in one single box, change or classify their status and reply to them.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/spellcheck.svg'),
                            title: i18n.t('Fix grammar & spelling'),
                            message: i18n.t(
                                'Receive notifications about the most critical events in your monitoring topic and be informed about everything you want.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/contract.svg'),
                            title: i18n.t('Improve copy'),
                            message: i18n.t(
                                'Track everything about your competitors , get feedback about their activity and compare with yours.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/tag.svg'),
                            title: i18n.t('Add hashtags'),
                            message: i18n.t(
                                'Get hashtags recommendations to optimize your content.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/add_reaction.svg'),
                            title: i18n.t('Add emojis'),
                            message: i18n.t(
                                'Get emojis suggestions to make your post standout.'
                            ),
                        },
                    ],
                },
            ],
            isNew: true,
        },
        {
            text: i18n.t('Publish & Schedule'),
            href: 'publishing-planning',
            image: require('./../../resources/images/category/publishing_hero.webp'),
            icon: require('./../../resources/icons/category/send.svg'),
            navbarMessage: i18n.t(
                'Content Creator designed to boost your performance when you are creating your social media posts.'
            ),
            message: i18n.t(
                'Create and plan your content in one single place and schedule it on an interactive calendar that can be managed in real time.'
            ),
            witness: {
                image: require('./../../resources/images/witness/publishWitness.webp'),
                logo: require('./../../resources/icons/witness/publishWitnessLogo.webp'),
                name: i18n.t('Elizabeth Fernandes,'),
                job: i18n.t('Head of Analytics and Audience Insights'),
                message: i18n.t(
                    'Swonkie allowed us to streamline our content distribution strategy on the various channels so that more readers find content of interest on the social network they frequent. It’s an easy-to-use platform. Using Swonkie, combined with quality analytical information, often leads Público to be the newspaper with the most online readers.'
                ),
            },
            categories: [
                {
                    message: i18n.t(
                        'Create posts with multiple images, carousels, stories, Reels, reposts and more;'
                    ),
                },
                {
                    message: i18n.t(
                        'Create schedules in the calendar with details of the publication to be prepared;'
                    ),
                },
                {
                    message: i18n.t(
                        'Add tags, location, UTM’s, first comment and CTA;'
                    ),
                },
                {
                    message: i18n.t(
                        'Integrate RSS Feeds to share automatically on social media;'
                    ),
                },
                {
                    message: i18n.t(
                        'Create, on the same schedule, posts with different images or text and a different time scheduled;'
                    ),
                },
                {
                    message: i18n.t(
                        'Schedule a post to be promoted directly on Facebook;'
                    ),
                },
                {
                    message: i18n.t(
                        'Export your calendar scheduled posts to a pdf doc;'
                    ),
                },
                {
                    message: i18n.t(
                        'Preview the feed on Instagram before you schedule it.'
                    ),
                },
            ],
            PageHome: {
                title: i18n.t(
                    'Content Creator designed to boost your performance when you are creating your social media posts.'
                ),
                message: i18n.t(
                    'Join your social media channels in one single menu where you can create the best content at the same time for all your social media networks. |You don’t need to create content jumping from one social media to another anymore.|'
                ),
                logos: [
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/renascena.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/smartkiss.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/cofina.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/betano.webp'),
                    },
                    {
                        language: 'es',
                        replaceId: 0,
                        logo: require('./../../resources/icons/logos/spm.webp'),
                    },
                    {
                        language: 'es',
                        replaceId: 1,
                        logo: require('./../../resources/icons/logos/pmarketing.webp'),
                    },
                    {
                        language: 'es',
                        replaceId: 2,
                        logo: require('./../../resources/icons/logos/acquajet.webp'),
                    },
                    {
                        language: 'pt-br',
                        replaceId: 0,
                        logo: require('./../../resources/icons/logos/inspira.webp'),
                    },
                    {
                        language: 'pt-br',
                        replaceId: 1,
                        logo: require('./../../resources/icons/logos/smart.webp'),
                    },
                    {
                        language: 'pt-br',
                        replaceId: 2,
                        logo: require('./../../resources/icons/logos/greenz.webp'),
                    },
                ],
            },
            content: [
                {
                    image: require('./../../resources/images/category/publishing_image1.webp'),
                    imageSize: 'Small',
                    isNew: true,
                    category: i18n.t('PUBLISH & SCHEDULE'),
                    title: i18n.t(
                        'Publish. Schedule. Queue. Your content everywhere.'
                    ),
                    media: {
                        text: i18n.t('Available on'),
                        medias: [
                            {
                                media: require('./../../resources/icons/smallLogos/facebook.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/instagram.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/twitter.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/linkedin.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/tiktok.svg'),
                            },
                            /*{
                                media: require('./../../resources/icons/smallLogos/pinterest.svg')
                            },*/
                            {
                                media: require('./../../resources/icons/smallLogos/blog.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/tumblr.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/wordpress.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/internet.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/googleStore.svg'),
                            },
                        ],
                    },
                    message: i18n.t(
                        'The easy way to get your consistency on social media to boost your presence, with innovative features to increase your options and to achieve the best performance of your content. \n\n |No more manual posting on social media. Partner with us to do the best work.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/carousel.svg'),
                            title: i18n.t('Carousel'),
                            message: i18n.t(
                                'Create carousel posts on Facebook and Instagram.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/my_location.svg'),
                            title: i18n.t('Target Audience'),
                            message: i18n.t(
                                'Choose who you want to reach from your audience on your Facebook organic posts.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/pin.svg'),
                            title: i18n.t('Location'),
                            message: i18n.t('Add your location to your posts.'),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/tag_faces.svg'),
                            title: i18n.t('Identify'),
                            message: i18n.t(
                                'Identify other profiles or pages in your posts, adding in your copy or photo.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/radar.svg'),
                            title: i18n.t('UTM'),
                            message: i18n.t(
                                'Add your UTM tags to your link on your posts to get more traffic information.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/cta.svg'),
                            title: i18n.t('CTA'),
                            message: i18n.t(
                                'Add a CTA on your Facebook posts directly.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/edit.svg'),
                            title: i18n.t('Customization'),
                            message: i18n.t(
                                'Create different copies, images or scheduled time for the same post.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/link.svg'),
                            title: i18n.t('Shortner'),
                            message: i18n.t(
                                'Create a short link for your posts on social media.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/publishing_image2.webp'),
                    imageSize: 'Big',
                    category: i18n.t('PUBLISH & SCHEDULE'),
                    title: i18n.t('Instagram features'),
                    message: i18n.t(
                        'Create your posts and stories, edit your style and leave it ready to be published. \n\n |All of this from your desktop.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/stories.svg'),
                            isNew: true,
                            title: i18n.t('Stories and Reels Editor'),
                            message: i18n.t(
                                'Design and create the best full-featured stories. \n Create and edit Reels and select the preview image.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/comment.svg'),
                            title: i18n.t('First Comment'),
                            message: i18n.t(
                                'Schedule your first comment on Instagram to be published along with your Instagram posts.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/menu-grid-r.svg'),
                            title: i18n.t('Grid'),
                            message: i18n.t(
                                'Create a grid for your timeline or divide one single image in multiple images to build your grid.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/export.svg'),
                            title: i18n.t('Export Feed'),
                            message: i18n.t(
                                'Export the Instagram feed with scheduled content and content awaiting approval.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/publishing_image3.webp'),
                    imageSize: 'Small',
                    category: i18n.t('PUBLISH & SCHEDULE'),
                    title: i18n.t('Plan. Share. Export.'),
                    message: i18n.t(
                        'With an intuitive calendar scheduling for your content where you can choose between a daily, weekly or monthly to preview all your content easily. \n\n |Drag and drop calendar to organize and manage your content faster than ever.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/export.svg'),
                            title: i18n.t('Export'),
                            message: i18n.t(
                                'Export your schedule posts to share with your clients to a pdf or powerpoint file in seconds. All content planned shareable easily.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/calendar.svg'),
                            title: i18n.t('Visual Planner'),
                            message: i18n.t(
                                'Differents views of your calendar to organize your content quickly and an efficient way to drag and drop your content wherever you want.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/filter_list.svg'),
                            title: i18n.t('Filter'),
                            message: i18n.t(
                                'Manage your content by social media channels, status, profiles and more to get the quick feedback you need.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/create.svg'),
                            title: i18n.t('Create'),
                            message: i18n.t(
                                'Create posts directly on your calendar to be faster than ever and to optimize your work.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/hashtag.svg'),
                            title: i18n.t('Hashtags group'),
                            message: i18n.t(
                                'Save groups of hashtags for each channel to create your publications faster.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/note.svg'),
                            title: i18n.t('Calendar Notes'),
                            message: i18n.t(
                                'Add calendar notes to scheduled publications to make it easier to communicate with clients and team members.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/share.svg'),
                            title: i18n.t('External calendar share'),
                            message: i18n.t(
                                'Share the calendar via a link or by email, with the different status of the publications. \n Full overview of the publication calendar in seconds.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/edit_calendar.svg'),
                            isNew: true,
                            title: i18n.t('Create Schedules'),
                            message: i18n.t(
                                'Add all the details of the post to create and assign to different teammates, so you have all the planning on the calendar.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/publishing_image5.webp'),
                    imageSize: 'Big',
                    category: i18n.t('PUBLISH & SCHEDULE'),
                    title: i18n.t('Create. Promote. Schedule.'),
                    message: i18n.t(
                        'The fastest way to promote content when you create your posts, with all the options you need for your ads to impact the right audience. \n\n |Don\'t waste more time promoting content on each social network. Use Swonkie to optimize your time and maximize your results.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/pin.png'),
                            title: i18n.t('Positioning'),
                            message: i18n.t(
                                'Define in which locations your ad will appear.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/devices.svg'),
                            title: i18n.t('Devices'),
                            message: i18n.t(
                                'Choose on which devices users will be impacted with your ads.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/audience.png'),
                            title: i18n.t('Audience'),
                            message: i18n.t(
                                'Include or exclude audience, to optimize the performance of your ads.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/calendar.png'),
                            title: i18n.t('Schedule'),
                            message: i18n.t(
                                'Schedule a publication and schedule the promotion, with a start and end date.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/publishing_image4.webp'),
                    imageSize: 'Big',
                    category: i18n.t('PUBLISH & SCHEDULE'),
                    title: i18n.t('RSS Feed. Queued Posts.'),
                    message: i18n.t(
                        'The easy way to integrate your RSS Feed to be shareable through queued hours and to deliver all your content with strategy. \n\n |Define the best hours to share your content directly from your RSS Feed.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/queue.svg'),
                            title: i18n.t('Manage Queues'),
                            message: i18n.t(
                                'Define your queues and the best times for your posts to be published and automate directly from your RSS feed. Specially for Publishers.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/schedule.svg'),
                            title: i18n.t('Facebook Schedule'),
                            message: i18n.t(
                                'Schedule directly for facebook to boost your post on business manager.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/eye.svg'),
                            title: i18n.t('Preview'),
                            message: i18n.t(
                                'See the posts in one single timeline with the native design for each social media.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/repeat.svg'),
                            title: i18n.t('Repeat'),
                            message: i18n.t(
                                'Double the post and define it to be rescheduled whenever your want.'
                            ),
                        },
                    ],
                },
            ],
        },
        {
            text: i18n.t('Reports & Insights'),
            href: 'reports-insights',
            image: require('./../../resources/images/category/Analytics_reporting.png'),
            icon: require('./../../resources/icons/category/Group 25895.svg'),
            navbarMessage: i18n.t(
                'Complete and easy-to-read reports to get the best insights about your social media performance.'
            ),
            witness: {
                image: require('./../../resources/images/witness/ReportsWitness.webp'),
                logo: require('./../../resources/icons/witness/reportsWitnessLogo.webp'),
                name: i18n.t('Ricardo Carneiro,'),
                job: i18n.t('Digital Marketing Coordinator'),
                message: i18n.t(
                    'Swonkie is an extremely complete platform. One of the few platforms on the market that allow us to manage all the Social Networks in an integrated manner. More than scheduling content, the platform allows you to create personalized reports instantly, analyze and monitor some competitors permanently. Swonkie team provides continuous monitoring and whenever questions arise, there is an operational team that answers almost in real time. A very complete platform. We recommend!'
                ),
            },
            message: i18n.t(
                'Getting all the metrics of your activity on social media no longer has to be tough. With customized reports you get the best insights for your business in few clicks.'
            ),
            categories: [
                {
                    message: i18n.t(
                        'Customize reports for Facebook, Instagram, LinkedIn, Youtube e Google My Business;'
                    ),
                },
                {
                    message: i18n.t(
                        'Get all the metrics for paid media on Facebook and Instagram;'
                    ),
                },
                {
                    message: i18n.t(
                        'Schedule the report to be sent on a day chosen by you;'
                    ),
                },
                {
                    message: i18n.t(
                        'Export to PDF, powerpoint or excel (.csv);'
                    ),
                },
                {
                    message: i18n.t(
                        'White labeling reports with your name and logo;'
                    ),
                },
                {
                    message: i18n.t(
                        'Compare different pages on the same report.'
                    ),
                },
            ],
            download: {
                title: i18n.t(
                    'Reports built to improve your social content strategy'
                ),
                message: i18n.t(
                    'We\'ve created our reports so you know what content works on each social network - and why. This information will help you continue doing what performs well.'
                ),
                buttonText: i18n.t('Download Report Sample'),
            },
            PageHome: {
                title: i18n.t(
                    'Complete and easy-to-read reports to get the best insights about your social media performance.'
                ),
                message: i18n.t(
                    'Understand all the KPI’s on social media with the most complete reports on the market, all customizabled and ready to send to your client. \n\n |You no longer have to waste time on spreadsheets or building powerpoint charts.|'
                ),
                logos: [
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/decathlon.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/digital_experience.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/nossa.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/partners.webp'),
                    },
                    {
                        language: 'es',
                        replaceId: 0,
                        logo: require('./../../resources/icons/logos/easy_work.webp'),
                    },
                    {
                        language: 'es',
                        replaceId: 1,
                        logo: require('./../../resources/icons/logos/area_marketing.webp'),
                    },
                    {
                        language: 'es',
                        replaceId: 2,
                        logo: require('./../../resources/icons/logos/deccom.webp'),
                    },
                    {
                        language: 'es',
                        replaceId: 3,
                        logo: require('./../../resources/icons/logos/newsell.webp'),
                    },
                ],
            },
            content: [
                {
                    image: require('./../../resources/images/category/reports_image1.webp'),
                    imageSize: 'Small',
                    category: i18n.t('Reports & Insights'),
                    title: i18n.t(
                        'Measure. Analyse. Improve. \n Understand your success on social media easily.'
                    ),
                    message: i18n.t(
                        'Complete and easy-to-read reports for all your social media channels. Get all the insights in minutes without any efforts creating reports during hours. \n\n |All the organic and paid metrics in your hand in a few clicks.|'
                    ),
                    media: {
                        text: i18n.t('Available on'),
                        medias: [
                            {
                                media: require('./../../resources/icons/smallLogos/facebook.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/instagram.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/linkedin.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/youtube.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/googleStore.svg'),
                            },
                        ],
                    },
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/chart.svg'),
                            title: i18n.t('Overview'),
                            message: i18n.t(
                                'Get de main KPI’s in a simple overview to understand easily your performance.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/equalizer.svg'),
                            title: i18n.t('Dynamic'),
                            message: i18n.t(
                                'Select wich metrics you want to include in your reports and add second axis on your reports to do comparative analysis between metrics.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/compare.svg'),
                            title: i18n.t('Compare'),
                            message: i18n.t(
                                'Compare pages or profiles on the same report and get the comparative performance between them instantly.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/trending_up.svg'),
                            title: i18n.t('Boosted Posts Insights'),
                            message: i18n.t(
                                'Get all the informations about your boosts.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/hashtag.svg'),
                            title: i18n.t('Hashtags'),
                            message: i18n.t(
                                'See the performance about the hashtags used on your posts.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/stories.svg'),
                            title: i18n.t('Stories Analytics'),
                            message: i18n.t(
                                'Get all the performance on your stories. The most complete stories reports on the market.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/timelapse.svg'),
                            title: i18n.t('Best Time Posts'),
                            message: i18n.t(
                                'Know the best time where your posts perform better to understand, on average, when is better for you publish content.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/performance.svg'),
                            title: i18n.t('Best Performance Posts'),
                            message: i18n.t(
                                'Receive detailed informations about your posts to understand how they perform.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/reports_image2.webp'),
                    imageSize: 'Big',
                    category: i18n.t('Reports & Insights'),
                    title: i18n.t('In-depth Analytics.'),
                    message: i18n.t(
                        'All the crucial metrics for your business and about your performance on social media, given to you quickly.\n\n |The most complete reports for social media on the market.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/user.svg'),
                            title: i18n.t('Engagement Rate'),
                            message: i18n.t(
                                'Understand how is your engagement according to your audience and to discover your most engaging content (or not engaging).'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/call_made.svg'),
                            title: i18n.t('Growth'),
                            message: i18n.t(
                                'Understand the performance of each metric, with maximum, minimum, average and totals in all metrics. Compare metrics in our graphs.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/volume_up.svg'),
                            title: i18n.t('Buzz Rate'),
                            message: i18n.t(
                                'Understand how viral is your content with a special metrics that gives you that insight.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/image.svg'),
                            title: i18n.t('Type & Formats'),
                            message: i18n.t(
                                'See all the metrics detailed on our reports, by content types ( organic or paid ), formats ( text, video, etc.. ) and much more.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/reports_image3.webp'),
                    imageSize: 'Small',
                    category: i18n.t('Reports & Insights'),
                    title: i18n.t(
                        'Paid Metrics. ROI.\nUnderstand all your investment KPI’s.'
                    ),
                    message: i18n.t(
                        'Get all the insights for your social media investment in one easy-to-read reports. Visualize all the triggers for your investment in advertisement and create the report in few seconds. \n\n |Analyse with efficiency|.'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/bullhorn-outline.svg'),
                            title: i18n.t('Ads Overview'),
                            message: i18n.t(
                                'The main KPI’s per each business account with all metrics calculated.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/briefcase.svg'),
                            title: i18n.t('Ads Campaign'),
                            message: i18n.t(
                                'A specific ad report per each campaign, with all details available from API, to get all the information.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/insights.svg'),
                            title: i18n.t('Metrics'),
                            message: i18n.t(
                                'All the metrics such as, Spend, Impressions, Reach, Frequency, CPC, CTR, CPM, Clicks and much more. All metrics detailed.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/performance.svg'),
                            title: i18n.t('Performance'),
                            message: i18n.t(
                                'All the information about your performance on ads and per post in each ad campaign. Get the best performed posts.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/reports_image4.webp'),
                    imageSize: 'Big',
                    category: i18n.t('Reports & Insights'),
                    title: i18n.t(
                        'Create. Update. Report.\nAll the metrics for your brands and clients.'
                    ),
                    message: i18n.t(
                        'Create a customizable reports and automate the process by scheduling reports in advance which land directly in your client’s inbox. Create unlimited reports, add their logo et voilà. \n\n |Automated, customizable, detailed and white label reports.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/smartphone-chip.svg'),
                            title: i18n.t('Automate'),
                            message: i18n.t(
                                'Don’t worry anymore because you forgot to send the report. Automate the process by scheduling reports in advance which land directly in your client’s inbox.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/edit.svg'),
                            title: i18n.t('Customize'),
                            message: i18n.t(
                                'Create beautiful and powerful reports for your clients and decide which metrics are best to include in each report. Exportable to PDF, powerpoint and CSV.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/face.svg'),
                            title: i18n.t('Personalize'),
                            message: i18n.t(
                                'Your clients like when you take care of them. Show your professionalism and send a personalized reports with their brand and name automatically.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/infinity.svg'),
                            title: i18n.t('Unlimited'),
                            message: i18n.t(
                                'The metrics are yours. We will not charge you for each report created. Create and schedule as many reports as you want and save it all.'
                            ),
                        },
                    ],
                },
            ],
        },
        {
            text: i18n.t('Competition & Benchmarking'),
            href: 'competition-benchmarking',
            image: require('./../../resources/images/category/Competitors.webp'),
            icon: require('./../../resources/icons/category/Group 25121.svg'),
            navbarMessage: i18n.t(
                'The perfect way to keep your competitors always under control.'
            ),
            message: i18n.t(
                'Be aware of your competitors’ activity in real time and be alert to every movement. Compare your results versus your competitors and do your benchmark through other businesses as well.'
            ),
            witness: {
                image: require('./../../resources/images/witness/brenchmarkWitness.webp'),
                logo: require('./../../resources/icons/witness/brenchmarkWitnessLogo.webp'),
                name: i18n.t('Eduardo André,'),
                job: i18n.t('Head of Social Media'),
                message: i18n.t(
                    'Swonkie transforms the working days of content managers, community managers and even of the most analytical on the team. As everything is concentrated in one single platform, from a simple post on Facebook, the weekly report, to the monitoring of the main competitors with direct email notifications, not having Swonkie to support our daily work became unimaginable. In addition to being a robust platform, 24/7 support works and resolves any situation that may happen.'
                ),
            },
            categories: [
                {
                    message: i18n.t(
                        'Get notifications about number of likes, comments, specific keywords or even viral posts from your competitors;'
                    ),
                },
                {
                    message: i18n.t(
                        'Create reports to compare the main KPI’s on social media from your competitors;'
                    ),
                },
                {
                    message: i18n.t('Get the best hashtags used by them;'),
                },
                {
                    message: i18n.t('Rank the best performed posts from them;'),
                },
                {
                    message: i18n.t(
                        'Export the reports to PDF and powerpoint.'
                    ),
                },
            ],
            download: {
                title: i18n.t(
                    'Reports built to improve your social content strategy'
                ),
                message: i18n.t(
                    'We\'ve created our reports so you know what content works on each social network - and why. This information will help you continue doing what performs well.'
                ),
                buttonText: i18n.t('Download Report Sample'),
            },
            PageHome: {
                title: i18n.t(
                    'The perfect way to keep your competitors always under control.'
                ),
                message: i18n.t(
                    'Get real-time insights about your competitors and benchmark them to compare the results on social media.\n\n|You don’t need to waste time scrolling through competitors’ feeds to get insights about their activity.|'
                ),
                logos: [
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/Jtinn.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/clever.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/recordtv.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/rtp.webp'),
                    },
                    {
                        language: 'es',
                        replaceId: 0,
                        logo: require('./../../resources/icons/logos/shootfy.webp'),
                    },
                    {
                        language: 'es',
                        replaceId: 1,
                        logo: require('./../../resources/icons/logos/mortadelaymedia.webp'),
                    },
                ],
            },
            content: [
                {
                    image: require('./../../resources/images/category/competitors_image1.webp'),
                    imageSize: 'Small',
                    category: i18n.t('Competition & Benchmarking'),
                    title: i18n.t(
                        'Don’t Spy. Audit. \n Don’t Copy. Benchmark.'
                    ),
                    message: i18n.t(
                        'Understand how your competitors are doing their work and their performance. Do your benchmark to use against your own.\n\n |Audit your competitors in real time to find inspiration and to improve your strategy.|'
                    ),
                    media: {
                        text: i18n.t('Available on'),
                        medias: [
                            {
                                media: require('./../../resources/icons/smallLogos/facebook.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/instagram.svg'),
                            },
                        ],
                    },
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/screen.svg'),
                            title: i18n.t('Monitoring'),
                            message: i18n.t(
                                'Create alerts for each competitor you have and be notified in real time about their activity.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/trophy.svg'),
                            title: i18n.t('Viral Content'),
                            message: i18n.t(
                                'Know in real time when your competitors are reaching a new viral post and what’s the subject about.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/folder.svg'),
                            title: i18n.t('Organize'),
                            message: i18n.t(
                                'Get all your competitors in one feed and read all the content at the same time, defining your search by different criteria.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/file-document.svg'),
                            title: i18n.t('Content Engagement'),
                            message: i18n.t(
                                'See all the engagement from their posts and see what their audience is talking about.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/competitors_image2.webp'),
                    imageSize: 'Big',
                    category: i18n.t('Competition & Benchmarking'),
                    title: i18n.t(
                        'Track. Inspire. Improve. \n Be always ahead.'
                    ),
                    message: i18n.t(
                        'All the crucial metrics for your business and about your performance on social media, given to you quickly.\n\n |The most complete reports for social media on the market.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/compare.svg'),
                            title: i18n.t('Compare'),
                            message: i18n.t(
                                'Add your competitors and compare their results with yours. Get the comparative insights for each metric and see which you are better at or need to improve.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/hashtag.svg'),
                            title: i18n.t('Hashtags'),
                            message: i18n.t(
                                'Understand which hashtags are used to grow their audience, reach and engagement.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/call_made.svg'),
                            title: i18n.t('Growth'),
                            message: i18n.t(
                                'Get the performance for each metric and understand where your competitors are growing more.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/performance.svg'),
                            title: i18n.t('Best Performance Posts'),
                            message: i18n.t(
                                'All the information about your competitors’ posts compared to yours to see which posts performed better (or not).'
                            ),
                        },
                    ],
                },
            ],
        },
        {
            text: i18n.t('Team Workflow'),
            href: 'collaborative-workflow',
            image: require('./../../resources/images/category/Workflow_hero.webp'),
            icon: require('./../../resources/icons/category/Group 25122.svg'),
            navbarMessage: i18n.t(
                'An easy way to do collaborative work on social media with your teammates and clients.'
            ),
            message: i18n.t(
                'Work in a team and closer with your clients. Send posts to be approved by a member of your team and define the rule to be published. With an innovative system you can share a post to be approved by a client without logging in Swonkie.'
            ),
            witness: {
                image: require('./../../resources/images/witness/workflowWitness.webp'),
                logo: require('./../../resources/icons/witness/workflowWitnessLogo.webp'),
                name: i18n.t('Ricardo Lopes,'),
                job: i18n.t('Head Of Digital'),
                message: i18n.t(
                    'Our experience with Swonkie has been very positive as it has facilitated our workflow as a team.\nOne of our main problems was related to the quality and qualitative detail of the reporting of the brands we work in Social Media. With Swonkie, we started to have more objectivity, detail and quality in the final delivery of insights to our clients.\nUpdates to the platform are frequent and allow us to take a much more incisive analytical approach.\nI must mention the speed and competence of the customer support, that is always available and helps to solve any situation we may have or to understand how a new feature works within the platform. It is certainly the best Social Media management and analysis tool, in terms of price-quality ratio.'
                ),
            },
            categories: [
                {
                    message: i18n.t(
                        'Invite different members with different roles and accesses to social media channels;'
                    ),
                },
                {
                    message: i18n.t(
                        'Send posts to be approved, rejected or edited and get or send feedback about posts under construction;'
                    ),
                },
                {
                    message: i18n.t(
                        'Approve in bulk posts at the same time, with a preview timeline;'
                    ),
                },
                {
                    message: i18n.t(
                        'Work in different teams with just one login;'
                    ),
                },
                {
                    message: i18n.t('Integrated with Slack.'),
                },
            ],
            PageHome: {
                title: i18n.t(
                    'An easy way to do collaborative work on social media with your teammates and clients.'
                ),
                message: i18n.t(
                    'Eliminate the complexity of approving content with extra emails, clouds and sms. Concentrate all the content on a workflow system approval and the job is done. \n\n |You don’t need to waste time sending alerts for your content to be approved anymore.|'
                ),
                logos: [
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/fotosport.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/JAP.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/pestana.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/casais.webp'),
                    },
                ],
            },
            content: [
                {
                    image: require('./../../resources/images/category/workflow_image1.webp'),
                    imageSize: 'Small',
                    category: i18n.t('Team Workflow'),
                    title: i18n.t('Don’t do it alone.\n Do it with a team.'),
                    message: i18n.t(
                        'Work together and closer with your team members and your clients in a simple workflow to approve your content and get feedback in real time.\n\n|A faster way to get your content approved.|'
                    ),
                    media: {
                        text: ' ',
                        medias: [],
                    },
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/profile.svg'),
                            title: i18n.t('Account Management'),
                            message: i18n.t(
                                'Invite all the users you want. Bring together clients and team members with different roles in one simple workflow.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/supervised_user_circle.svg'),
                            title: i18n.t('Roles'),
                            message: i18n.t(
                                'Select which areas of the platform the users can access and what kind of permissions they have to do some action.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/check-o.svg'),
                            title: i18n.t('Validation'),
                            message: i18n.t(
                                'With a validation system that doesn’t let you send the wrong invitation. An auto confirmation process to validate new members.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/feedback.svg'),
                            title: i18n.t('Feedback'),
                            message: i18n.t(
                                'Leave your feedback on the post before approving or declining. Just leave a comment.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/workflow_image2.webp'),
                    imageSize: 'Big',
                    category: i18n.t('Team Workflow'),
                    title: i18n.t(
                        'Invite. Share. Send. \n Do not waste time sending emails anymore.'
                    ),
                    message: i18n.t(
                        'Send your posts directly to a member added to your team, add a message to them or send it directly by email. \n\n |An innovative feature allows clients or team members to approve the content sent without being connected on the platform.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/eye.svg'),
                            title: i18n.t('Post Preview'),
                            message: i18n.t(
                                'Get all the posts that need some action in two types of views. the list view or the feed view to fit with your modus operandi.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/dashboard.svg'),
                            title: i18n.t('Onboard'),
                            message: i18n.t(
                                'Manage in one dashboard all the users that you have on your team and onboard them easily at any moment.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/tag.svg'),
                            title: i18n.t('White Label'),
                            message: i18n.t(
                                'Send your posts to be approved by your clients without any Swonkie mark.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/mail.svg'),
                            title: i18n.t('Email Notification'),
                            message: i18n.t(
                                'All the users will send email notifications to do some action when you send them content.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/approval.png'),
                            title: i18n.t('Approval List'),
                            message: i18n.t(
                                'Send all contents to an approval list, so that the client receives only one email and is able to externally approve all contents.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/share.svg'),
                            title: i18n.t('Calendar and Instagram Feed Share'),
                            message: i18n.t(
                                'Externally share your calendar and Instagram feed so that team members or clients have full view of all content, even without being connected to Swonkie.'
                            ),
                        },
                    ],
                },
            ],
        },
        {
            text: i18n.t('Community Management & Inbox'),
            href: 'community-management-inbox',
            image: require('./../../resources/images/category/Community.webp'),
            icon: require('./../../resources/icons/category/Group 25119.svg'),
            navbarMessage: i18n.t(
                'A perfect hub to join all the comments and messages from your followers on social media.'
            ),
            message: i18n.t(
                'Engage easily with your followers, reply to their messages in your inbox, reply to comments and see your posts’ engagement in one feed through all your social media channels at the same time, without jumping from one social media channel to another.'
            ),
            witness: {
                image: require('./../../resources/images/witness/communityWitness.webp'),
                logo: require('./../../resources/icons/witness/communityWitnessLogo.webp'),
                name: i18n.t('Pedro Alves,'),
                job: i18n.t('Head of Digital'),
                message: i18n.t(
                    'Working with Swonkie started out as the answer to a need. We have improved our responsiveness in the day-to-day management of the various social networks we have under our jurisdiction, allowing an incalculable gain of time to focus on several additional tasks of our day-to-day lives. Nowadays it is no longer just an answer to a need, but an irreplaceable reality for digital marketing professionals like us, who work daily to give a quick but broadly qualitative answer to the challenges that are presented to us. Swonkie did not just help us to “schedule publications”, it has really helped us to take several steps forward in our daily management of Social Media.'
                ),
            },
            categories: [
                {
                    message: i18n.t('Reply to private messages on Facebook;'),
                },
                {
                    message: i18n.t(
                        'Create tags and notes per message received, assign each message to other team members, mark as favorite or as spam;'
                    ),
                },
                {
                    message: i18n.t(
                        'Export comments from any post directly to an excel file;'
                    ),
                },
                {
                    message: i18n.t(
                        'Reply to any comment on your post, delete, assign to other user, leave a note or create a tag per each post or comment;'
                    ),
                },
                {
                    message: i18n.t(
                        'See all engagement per post in one single feed.'
                    ),
                },
            ],
            PageHome: {
                title: i18n.t(
                    'A perfect hub for gathering all your followers’ comments and messages on social media.'
                ),
                message: i18n.t(
                    'It is possible to have your inbox zero on social media and all the comments replied in a simpler and faster way, managing everything in one single place. |You no longer need to reply by jumping from one social media inbox and feed to another.|'
                ),
                logos: [
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/adagietto.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/livecontent.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/vida_ativa.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/remax.webp'),
                    },
                ],
            },
            content: [
                {
                    image: require('./../../resources/images/category/community_image1.webp'),
                    imageSize: 'Small',
                    category: i18n.t('Community Management & Inbox'),
                    title: i18n.t('Don’t just reply. \n Engage, truly.'),
                    message: i18n.t(
                        'Get all your social media comments in one feed and manage it from there. \n\n |All the functionalities to engage with them efficiently. Make your community management a piece of cake.|'
                    ),
                    media: {
                        text: ' ',
                        medias: [],
                    },
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/reply_all.svg'),
                            title: i18n.t('Engage & Manage'),
                            message: i18n.t(
                                'Reply to comments, edit, delete, assign to other user to reply, hide or change the status. All the power to you.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/export.svg'),
                            title: i18n.t('Export'),
                            message: i18n.t(
                                'Export all the comments to an excel file with their engagement data to find anything you want faster.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/notes.svg'),
                            title: i18n.t('Notes'),
                            message: i18n.t(
                                'Leave notes to other users of your team, attached to any post.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/tag.svg'),
                            title: i18n.t('Tags'),
                            message: i18n.t(
                                'Add any tag to identify later any post on your feed.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/community_image2.webp'),
                    imageSize: 'Big',
                    category: i18n.t('Community Management & Inbox'),
                    title: i18n.t('The Mission? Inbox Zero.'),
                    message: i18n.t(
                        'Manage the inbox of your social media channels from one unique place. All your messages ready to be replied and managed by you easily and never let customer questions overwhelm you. \n\n |Don’t miss any message. It’s time of inbox zero.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/reply.svg'),
                            title: i18n.t('Reply'),
                            message: i18n.t(
                                'Reply to all messages instantly and see all the historic. Interact with your followers and improve your customer support across social media.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/verified_user.svg'),
                            title: i18n.t('Manage'),
                            message: i18n.t(
                                'Mark as unread, spam, favorite or move to trash. Change the status of your message whenever you want.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/assignment_ind.svg'),
                            title: i18n.t('Assign'),
                            message: i18n.t(
                                'Choose the right team member to reply to each message with easy-to-use team assignments.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/notes.svg'),
                            title: i18n.t('Notes & Tags'),
                            message: i18n.t(
                                'Leave a note to any team member or tag the conversation to leave more details for your team.'
                            ),
                        },
                    ],
                },
            ],
        },
        /*{
            text: i18n.t('Influence Marketing'),
            href: 'influencer-marketing',
            image: require('./../../resources/images/category/influence_hero.webp'),
            icon: require('./../../resources/icons/category/Group 25120.svg'),
            navbarMessage: i18n.t('Define the best influence marketing strategy, analyzing all the data you really need.'),
            message: i18n.t('Discover the best influencers for your business instantly. Get the analysis of each influencer with a performance score, to compare each of them by industry. Everything you need to start an influence marketing strategy.'),
            witness: {
                image: require('./../../resources/images/witness/influencerWitness.webp'),
                logo: require('./../../resources/icons/witness/influencerWitnessLogo.webp'),
                name: i18n.t('Catia Matias & Sofia Almeida,'),
                job: i18n.t('Social Media Supervisor & Community Manager'),
                message: i18n.t('Swonkie is a unique tool in social media management. The fact that it allows us to schedule content is a fundamental help in our daily work, especially at weekends. The reports are very complete and help us to have a more detailed analysis of our clients\' networks. The whole team is super available and is always just a click away.')
            },
            categories: [
                {
                    message: i18n.t('Search by name, handle, hashtags or industry;')
                },
                {
                    message: i18n.t('See the main KPI’s, demography, hashtags or mentions;')
                },
                {
                    message: i18n.t('Know the best performing posts;')
                },
                {
                    message: i18n.t('Get the brands mentioned by each influencer or who mentions more some influencer;')
                },
                {
                    message: i18n.t('Compare influencers through their main public KPI’s and get analysis in real time.')
                }
            ],
            PageHome: {
                title: i18n.t('Define the best influence marketing strategy, analyzing all the data you really need.'),
                message: i18n.t('Find the best influencers for your business and create a strategy based on their content. Compare influencers to see who has the highest influence score on Swonkie. \n\n |You no longer need to request more prints about their performance and growth.|'),
                logos: [
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/7skin.webp')
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/quintadolago.webp')
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/carris.webp')
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/zippy.webp')
                    }
                ]
            },
            content: [
                {
                    image: require('./../../resources/images/category/influence_image1.webp'),
                    imageSize: 'Small',
                    category: i18n.t('Influence Marketing'),
                    title: i18n.t('Don’t Show-off. \n Just Influence, truly.'),
                    message: i18n.t('Find the best influencers for your business and create a strategy based on their content. See the main KPI’s and understand their performance with an AI influence score to compare influencers.\n\n |Get the best advocates for your business.|'),
                    media: {
                        text: ' ',
                        medias: []
                    },
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/performance.svg'),
                            title: i18n.t('Performance'),
                            message: i18n.t('Check the main KPI’s to see the performance of any influencer and see their evolution.')
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/search.svg'),
                            title: i18n.t('Advanced Search'),
                            message: i18n.t('Find the best influencers with a tuned filter by age, gender, country, language, industry, audience and more, to get the best options for you.')
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/favorite_border.svg'),
                            title: i18n.t('Favorites'),
                            message: i18n.t('Save your searches to see later in one simple feed to access any time.')
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/score.svg'),
                            title: i18n.t('Score'),
                            message: i18n.t('With a powerful algorithm that combines all the main KPI’s to check the real performance and compare with other influencers.')
                        }
                    ]
                },
                {
                    image: require('./../../resources/images/category/influence_image2.webp'),
                    imageSize: 'Big',
                    category: i18n.t('Influence Marketing'),
                    title: i18n.t('An end-to-end discover solution for the best influence marketing strategy.'),
                    message: i18n.t('Don’t search or google it anymore. Just use our advanced search to find the perfect match for your business. With a complete searching mode, identify your criteria and Swonkie will do the search for you. \n\n |Don’t Google it, Swonkie it.|'),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/call_made.svg'),
                            title: i18n.t('Top Posts'),
                            message: i18n.t('See the best performing posts and see if the content was sponsored by a brand.')
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/alternate_email.svg'),
                            title: i18n.t('Mentions'),
                            message: i18n.t('Get easily all the brands mentioned by any influencer to see if they work with your competitor or check what kind of brands mention this influencer.')
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/hashtag.svg'),
                            title: i18n.t('Hashtags'),
                            message: i18n.t('Understand the performance per hashtag and what kind of hashtags this influencer uses to prevent any fraud engagement. (e.g. #likeforlike).')
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/related.svg'),
                            title: i18n.t('Related Influencers'),
                            message: i18n.t('Discover other related influencers from your search to see other options with a similar performance.')
                        }
                    ]
                }
            ]
        },*/
        {
            text: i18n.t('Social Media & Web Listening'),
            href: 'listening',
            image: require('./../../resources/images/category/listening_hero.webp'),
            icon: require('./../../resources/icons/category/listening_icon.svg'),
            navbarMessage: i18n.t(
                'Continuous monitoring across Social and Web sources to track all mentions and stay up to date on your online reputation.'
            ),
            message: i18n.t(
                'Monitor and track your online reputation and measure the brand’s performance. A continuous monitoring activity to listen all about your brand, 24/7, and to increase your customer satisfaction.'
            ),
            witness: {
                image: require('./../../resources/images/witness/listeningWitnessImage.webp'),
                logo: require('./../../resources/icons/witness/listeningWitnessLogo.webp'),
                name: i18n.t('Tiago Lopes,'),
                job: i18n.t('Social Media Editor & Community Manager'),
                message: i18n.t(
                    'Since I started working with Swonkie, the day-to-day work in different social networks has become very easy to plan. With a user-friendly interface and customer support that has always answered my questions, Swonkie is now an indispensable tool for managing our brands on various platforms.'
                ),
            },
            categories: [
                {
                    message: i18n.t(
                        'To track all the mentions about your brand, your business or competitors;'
                    ),
                },
                {
                    message: i18n.t(
                        'To get the sentiment analysis on mentions where you are identified;'
                    ),
                },
                {
                    message: i18n.t(
                        'To identify the top influencers who most mention your brand;'
                    ),
                },
                {
                    message: i18n.t(
                        'To know trends related to the terms you are monitoring;'
                    ),
                },
                {
                    message: i18n.t(
                        'To measure all the main KPI’s and get all the insights about your activity;'
                    ),
                },
            ],
            PageHome: {
                title: i18n.t(
                    'Monitor and track your online reputation and measure the brand’s performance.'
                ),
                message: i18n.t(
                    'A continuous monitoring activity to listen all about your brand or competitors, 24/7, to get worthwhile information to improve your business. \n\n |Never miss a mention about your brand, respond in time to an unsatisfied customer before the story gets ahead of you and protect your online reputation.|'
                ),
                logos: [
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/brisa.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/macromakers.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/phb.webp'),
                    },
                    {
                        language: '',
                        replaceId: '',
                        logo: require('./../../resources/icons/logos/sol.webp'),
                    },
                ],
            },
            content: [
                {
                    image: require('./../../resources/images/category/listening_image1.webp'),
                    imageSize: 'Small',
                    category: i18n.t('Social Media & Web Listening'),
                    title: i18n.t(
                        'Discover. Track. Listen. \n Continuous monitoring across Social and Web sources.'
                    ),
                    media: {
                        text: i18n.t('Available on'),
                        medias: [
                            {
                                media: require('./../../resources/icons/smallLogos/facebook.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/instagram.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/youtube.svg'),
                            },
                            /*{
                                media: require('./../../resources/icons/smallLogos/pinterest.svg')
                            },*/
                            {
                                media: require('./../../resources/icons/smallLogos/reddit.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/tumblr.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/blog.svg'),
                            },
                            {
                                media: require('./../../resources/icons/smallLogos/internet.svg'),
                            },
                        ],
                    },
                    message: i18n.t(
                        'The best way to track everything about your brand, your keywords, topics related to your business and even about your competitor’s activity. Monitor everything in seconds. \n\n |Stop wasting time browsing all the social media and web channels to do market research for your business. It’s time to unlock all the hidden data across all social media and web channels.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/my_location.svg'),
                            title: i18n.t('Track'),
                            message: i18n.t(
                                'Find all the relevant mentions about anything or anyone that matters to your business and activity.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/tag_faces.svg'),
                            title: i18n.t('Sentiment Analysis'),
                            message: i18n.t(
                                'Get the sentiment detected in all  mentions tracked in your search, to understand  positive, negative or neutral feedback.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/trophy.svg'),
                            title: i18n.t('Top Influencers'),
                            message: i18n.t(
                                'Identify who most mentions your brand and understand the real impact of it.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/trending_up.svg'),
                            title: i18n.t('Trends'),
                            message: i18n.t(
                                'Identify all the related topics associated with your searches and interest, to understand other upcoming opportunities.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/listening_image2.webp'),
                    imageSize: 'Big',
                    category: i18n.t('Social Media & Web Listening'),
                    title: i18n.t(
                        'Feedback. Engage. Protect. \n Improve customer satisfaction.'
                    ),
                    message: i18n.t(
                        'Get all the conversations about your brand or related terms that matter most and concentrate everything in one single box to reply and to manage it. Evaluate all the comments and mentions to measure your online reputation. \n\n |Identify customer issues before they turn into bigger problems and interact with them easily and quickly.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/comment.svg'),
                            title: i18n.t('Engage'),
                            message: i18n.t(
                                'Access and engage with your mentions to increase customer satisfaction and never miss one again.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/folder.svg'),
                            title: i18n.t('Manage'),
                            message: i18n.t(
                                'Manage all mentions in one single box, change or classify their status and reply to them.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/folder.svg'),
                            title: i18n.t('Notifications'),
                            message: i18n.t(
                                'Receive notifications about the most critical events in your monitoring topic and be informed about everything you want.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/compare.svg'),
                            title: i18n.t('Competition'),
                            message: i18n.t(
                                'Track everything about your competitors , get feedback about their activity and compare with yours.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/listening_image3.webp'),
                    imageSize: 'Small',
                    category: i18n.t('Social Media & Web Listening'),
                    title: i18n.t(
                        'Monitor. Measure. Analyse. \n Get the full impact of your social media activity in simpler and more beautiful reports.'
                    ),
                    message: i18n.t(
                        'Get the best reports that will give you insights to boost your business and activity. Analyse all your brand metrics and understand the impact on different channels and sources. \n\n |We track every corner on the web and social media to give you all of this concentrated on the best reports, to power up your knowledge.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/ruler.svg'),
                            title: i18n.t('Measure'),
                            message: i18n.t(
                                'Track the main KPI’s, such as estimated reach, engagement, sentiment analysis and more.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/equalizer.svg'),
                            title: i18n.t('Insights'),
                            message: i18n.t(
                                'Get the best analysis to have the best insights into your business and decide where the opportunity to improve and grow is.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/file-document.svg'),
                            title: i18n.t('Reports'),
                            message: i18n.t(
                                'Automated reports to save time on all analysis with all the metrics important to your business. Export reports in different formats.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/performance.svg'),
                            title: i18n.t('Performance'),
                            message: i18n.t(
                                'See the top performing content or mentions based on your search and see all the data related to them.'
                            ),
                        },
                    ],
                },
                {
                    image: require('./../../resources/images/category/listening_image4.webp'),
                    imageSize: 'Small',
                    category: i18n.t('Social Media & Web Listening'),
                    title: i18n.t(
                        'Research. Real-time. Alerts. \n Get a powerful dashboard in real-time on a big screen.'
                    ),
                    message: i18n.t(
                        'The best way to keep your teams up to date on everything, with a specific dashboard updated in real time. \n\n |Control everything about your brand, competitors, keywords related to your business and everything you want.|'
                    ),
                    features: [
                        {
                            icon: require('./../../resources/icons/category/feature/search.svg'),
                            title: i18n.t('Advanced Search'),
                            message: i18n.t(
                                'Advanced search through "and", "or", "and not" and "proximity" queries, so you monitor only what is relevant to your brand.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/history.png'),
                            title: i18n.t('History'),
                            message: i18n.t(
                                'View the changes history of the project, to see what was changed and who was responsible for the change.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/exclude.png'),
                            title: i18n.t('Delete Pages'),
                            message: i18n.t(
                                'Exclude your pages, so that their contents are not monitored in the project.'
                            ),
                        },
                        {
                            icon: require('./../../resources/icons/category/feature/export.svg'),
                            title: i18n.t('Export Mentions'),
                            message: i18n.t(
                                'Export the project mentions as PDF, to get a complete view of all the pages that mentioned your brand.'
                            ),
                        },
                    ],
                },
            ],
        },
    ],
    plans: [
        {
            toggleType: 'Left',
            type: 'Primary',
            icon: require('./../../resources/icons/plan/Starter.svg'),
            title: 'Starter',
            priceMonthly: '00.00€',
            textMonthly: i18n.t('/month'),
            billedMonthly: i18n.t('Billed monthly'),
            priceYearly: '00.00€',
            textYearly: i18n.t('/year'),
            billedYearly: i18n.t('Billed yearly'),
            priceCategories: [
                {
                    categoryText: i18n.t('|{{number}}| Social Profiles', {
                        number: 10,
                    }),
                },
                {
                    categoryText: i18n.t('|{{number}}| Users', { number: 1 }),
                },
                {
                    categoryText: i18n.t('*Competitors*'),
                },
                /*{
                    categoryText: i18n.t('|{{number}}| Influencers Searches', { number: 5 })
                },*/
                {
                    categoryText: i18n.t('*Mentions*'),
                },
                {
                    categoryText: i18n.t('|{{number}}| ANDIE Credits', {
                        number: 100,
                    }),
                },
            ],
        },
        {
            toggleType: 'Right',
            type: 'Primary',
            icon: require('./../../resources/icons/plan/Friendly.svg'),
            title: 'Friendly',
            priceMonthly: '00.00€',
            textMonthly: i18n.t('/month'),
            billedMonthly: i18n.t('Billed monthly'),
            priceYearly: '00.00€',
            textYearly: i18n.t('/year'),
            billedYearly: i18n.t('Billed yearly'),
            priceCategories: [
                {
                    categoryText: i18n.t('|{{number}}| Social Profiles', {
                        number: 15,
                    }),
                },
                {
                    categoryText: i18n.t('|{{number}}| Users', { number: 3 }),
                },
                {
                    categoryText: i18n.t('|{{number}}| Competitors', {
                        number: 2,
                    }),
                },
                /*{
                    categoryText: i18n.t('|{{number}}| Influencers Searches', { number: 20 })
                },*/
                {
                    categoryText: i18n.t('|{{number}}| Mentions', {
                        number: 1000,
                    }),
                },
                {
                    categoryText: i18n.t('|{{number}}| ANDIE Credits', {
                        number: 500,
                    }),
                    isNew: true,
                },
            ],
        },
        {
            toggleType: 'Right',
            type: 'Primary',
            icon: require('./../../resources/icons/plan/Lover.svg'),
            title: 'Lover',
            priceMonthly: '00.00€',
            textMonthly: i18n.t('/month'),
            billedMonthly: i18n.t('Billed monthly'),
            priceYearly: '00.00€',
            textYearly: i18n.t('/year'),
            billedYearly: i18n.t('Billed yearly'),
            priceCategories: [
                {
                    categoryText: i18n.t('|{{number}}| Social Profiles', {
                        number: 30,
                    }),
                },
                {
                    categoryText: i18n.t('|{{number}}| Users', { number: 5 }),
                },
                {
                    categoryText: i18n.t('|{{number}}| Competitors', {
                        number: 5,
                    }),
                },
                /*{
                    categoryText: i18n.t('|{{number}}| Influencers Searches', { number: 40 })
                },*/
                {
                    categoryText: i18n.t('|{{number}}| Mentions', {
                        number: 3000,
                    }),
                },
                {
                    categoryText: i18n.t('|{{number}}| ANDIE Credits', {
                        number: 1000,
                    }),
                    isNew: true,
                },
            ],
        },
        {
            toggleType: 'Right',
            type: 'Secundary',
            icon: require('./../../resources/icons/plan/Pro.svg'),
            title: 'Pro',
            priceMonthly: '00.00€',
            textMonthly: i18n.t('/month'),
            billedMonthly: i18n.t('Billed monthly'),
            priceYearly: '00.00€',
            textYearly: i18n.t('/year'),
            billedYearly: i18n.t('Billed yearly'),
            mostSubscribed: true,
            priceCategories: [
                {
                    categoryText: i18n.t('|{{number}}| Social Profiles', {
                        number: 50,
                    }),
                },
                {
                    categoryText: i18n.t('|{{number}}| Users', { number: 10 }),
                },
                {
                    categoryText: i18n.t('|{{number}}| Competitors', {
                        number: 10,
                    }),
                },
                /*{
                    categoryText: i18n.t('|{{number}}| Influencers Searches', { number: 75 })
                },*/
                {
                    categoryText: i18n.t('|{{number}}| Mentions', {
                        number: 6000,
                    }),
                },
                {
                    categoryText: i18n.t('|{{number}}| ANDIE Credits', {
                        number: 1500,
                    }),
                    isNew: true,
                },
            ],
        },
        {
            toggleType: 'Right',
            type: 'Primary',
            icon: require('./../../resources/icons/plan/Master.svg'),
            title: 'Master',
            priceMonthly: '00.00€',
            textMonthly: i18n.t('/month'),
            billedMonthly: i18n.t('Billed monthly'),
            priceYearly: '00.00€',
            textYearly: i18n.t('/year'),
            billedYearly: i18n.t('Billed yearly'),
            priceCategories: [
                {
                    categoryText: i18n.t('|{{number}}| Social Profiles', {
                        number: 100,
                    }),
                },
                {
                    categoryText: i18n.t('|{{number}}| Users', { number: 15 }),
                },
                {
                    categoryText: i18n.t('|{{number}}| Competitors', {
                        number: 20,
                    }),
                },
                /*{
                    categoryText: i18n.t('|{{number}}| Influencers Searches', { number: 150 })
                },*/
                {
                    categoryText: i18n.t('|{{number}}| Mentions', {
                        number: 12000,
                    }),
                },
                {
                    categoryText: i18n.t('|{{number}}| ANDIE Credits', {
                        number: 2500,
                    }),
                    isNew: true,
                },
            ],
        },
    ],
    witness: [
        {
            area: 'main',
            language: '',
            replaceId: '',
            image: require('./../../resources/images/witness/firstWitness.webp'),
            logo: require('./../../resources/icons/witness/firstwitnessLogo.webp'),
            name: i18n.t('Filipa Subtil,'),
            job: i18n.t('Social Media Manager'),
            message: i18n.t(
                'In the competitive market of social media management platforms, Swonkie stands out for the features it offers (and they keep on increasing), for the very intuitive interface and for the support team, always available. Of the features, I highlight the reports, very complete and easy to interpret. Swonkie is undoubtedly an asset for any team.'
            ),
        },
        {
            area: 'main',
            language: '',
            replaceId: '',
            image: require('./../../resources/images/witness/secondWitness.webp'),
            logo: require('./../../resources/icons/witness/secondWitnessLogo.webp'),
            name: i18n.t('Nelson Pimenta,'),
            job: i18n.t('Director Digital'),
            message: i18n.t(
                'Swonkie has revolutionized the way we manage the social networks of our brands – Rádio Renascença, RFM and Megahits. With this tool we are able to optimize all the processes, from creation to content distribution, analysis and reporting, in a systematic way and with visible results. The support is fantastic and the entire Swonkie team devotes a lot of time to helping to improve services based on our feedback.'
            ),
        },
        {
            area: 'main',
            language: '',
            replaceId: '',
            image: require('./../../resources/images/witness/thirdWitness.webp'),
            logo: require('./../../resources/icons/witness/thirdWitnessLogo.webp'),
            name: i18n.t('Ricardo Nunes,'),
            job: i18n.t('Branded Content Director'),
            message: i18n.t(
                'In a world where our content creation proposal happens at the speed of real life on the brands\' social media platforms, it is essential for us to have an integrative platform that allows us to gather insights to build robust strategies. Swonkie gives us that value and knowledge. The availability of the development and support team is total and allows us to build and adapt the platform to our needs.'
            ),
        },
        {
            area: 'main',
            language: 'es',
            replaceId: 0,
            image: require('./../../resources/images/witness/firstWitnessSpanish.webp'),
            logo: require('./../../resources/icons/witness/firstWitnessSpanishLogo.webp'),
            name: i18n.t('Meritxell Querol,'),
            job: i18n.t('Digital Marketing Specialist'),
            message: i18n.t(
                'Swonkie cubre todas nuestras necesidades cuando se trata de administrar y publicar en las redes sociales. Es una plataforma muy intuitiva y fácil de usar. La respuesta de los técnicos es instantánea y por supuesto, ¡estamos encantados de trabajar con ellos!'
            ),
        },
        {
            area: 'plan',
            language: '',
            replaceId: '',
            image: require('./../../resources/images/witness/pricingWitness.webp'),
            logo: require('./../../resources/icons/witness/pricingWitnessLogo.webp'),
            name: i18n.t('Joana Lemos,'),
            job: i18n.t('Strategy & Social Media Director'),
            message: i18n.t(
                'As much or more than the differentiating processes and solutions, Swonkie is distinguished by People. And, nowadays, this is what we value most. having someone who is always there, who is a partner and who evolves with our needs. May it continue this way for a long time!'
            ),
        },
        {
            area: 'aboutUs',
            language: '',
            replaceId: '',
            image: require('./../../resources/images/witness/AboutfirstWitness.webp'),
            name: i18n.t('Andreia Silva,'),
            job: i18n.t('Head of Customer Happiness Support'),
            message: i18n.t(
                'Working at Swonkie is working in a dynamic and united team, where we help and support each other and that, above all, has a mission in common - to facilitate and optimize our clients’ work in managing social networks!'
            ),
        },
        {
            area: 'aboutUs',
            language: '',
            replaceId: '',
            image: require('./../../resources/images/witness/AboutsecondWitness.webp'),
            name: i18n.t('Henrique Mota,'),
            job: i18n.t(i18n.t('Full Stack Developer')),
            message: i18n.t(
                'The dedication and devotion to the work spirit in Swonkie’s team is something incomparable and phenomenal. The persistence, the daily focus make us able to face the imposed challenges. This way, we will achieve our goals as a team! It’s a privilege to be part of this family.'
            ),
        },
        {
            area: 'aboutUs',
            language: '',
            replaceId: '',
            image: require('./../../resources/images/witness/AboutthirdWitness.webp'),
            name: i18n.t('Ricardo Pereira,'),
            job: i18n.t('Head of Sales'),
            message: i18n.t(
                'Swonkie is a digital company with a human DNA, great to work and to enhance personal, professional and collective growth on a very demanding basis. This is the only way to achieve dreams that come true as a team!'
            ),
        },
    ],
    reports: [
        {
            number: '+ 5 000',
            text: i18n.t('Clients'),
        },
        {
            number: '+ 25 000',
            text: i18n.t('Social Media Managers'),
        },
        {
            number: '+ 150 000',
            text: i18n.t('Profiles Added'),
        },
        {
            number: '+ 10 Million',
            text: i18n.t('Publications sent'),
        },
    ],
    comparePlansTable: [
        {
            id: 'Price',
            title: '',
            head: [
                {
                    title: 'Starter',
                },
                {
                    title: 'Friendly',
                },
                {
                    title: 'Lover',
                },
                {
                    title: 'Pro',
                },
                {
                    title: 'Master',
                },
            ],
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('Monthly price'),
                            message:
                                'Duis mauris augue, efficitur eu arcu sit amet, posuere dignissim neque. Aenean enim sem, pharetra et magna sit amet, luctus aliquet nibh. Curabitur auctor leo et libero consectetur gravida. Morbi gravida et sem dictum varius. Proin eget viverra sem, non euismod est. Maecenas facilisis urna in lectus aliquet venenatis. Etiam et metus nec mauris condimentum vulputate. Aenean volutpat odio quis egestas tempus. Fusce tempor vulputate luctus. Pellentesque vulputate viverra ex eget elementum. Aliquam ut feugiat felis.',
                        },
                    ],
                    content: [
                        {
                            text: '00.00€',
                        },
                        {
                            text: '00.00€',
                        },
                        {
                            text: '00.00€',
                        },
                        {
                            text: '00.00€',
                        },
                        {
                            text: '00.00€',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Social Profiles ( up to )'),
                            message: i18n.t(
                                'The number of social media profiles you can add per plan. A social profile is any social media page or account you manage. So, for example if you manage 4 Facebook Business pages, 5 Twitter accounts and 2 Linkedin pages, that would be 11 social profiles in total.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '10',
                        },
                        {
                            text: '15',
                        },
                        {
                            text: '30',
                        },
                        {
                            text: '50',
                        },
                        {
                            text: '100',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Team Members ( up to )'),
                            message: i18n.t(
                                'The maximum number of team members that can be added to the main account per plan.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '1',
                        },
                        {
                            text: '3',
                        },
                        {
                            text: '5',
                        },
                        {
                            text: '10',
                        },
                        {
                            text: '15',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Team Workflow'),
                            message: i18n.t(
                                'A team member can request approval of their post, which will be directed to the Posts Workflow Area. Both the account owner and users with permission to do so will have access to review and approve this content.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Competitors'),
                            message: i18n.t(
                                'The ability to track your competitors\' social media posts in real time and get them in a single feed where everything can be viewed on the same screen. You can add some specific alerts to track their activity as well.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '2',
                        },
                        {
                            text: '5',
                        },
                        {
                            text: '10',
                        },
                        {
                            text: '20',
                        },
                    ],
                },
                /*{
                    collapseButton: [
                        {
                            title: i18n.t('Influencers Searches'),
                            message: i18n.t('The maximum number of searches per month that can be done. If you search for a profile and click on it, it will count as one search. However, if you click on it in the same month, it will not count as a new search. As you can understand, this area gathers tons of data and we need to set limits.')
                        }
                    ],
                    content: [
                        {
                            text: '5'
                        },
                        {
                            text: '20'
                        },
                        {
                            text: '40'
                        },
                        {
                            text: '75'
                        },
                        {
                            text: '150'
                        }
                    ]
                },*/
                {
                    collapseButton: [
                        {
                            title: i18n.t('Ad Campaigns Reports'),
                            message: i18n.t(
                                'The maximum number of ads campaigns that can be selected to create different ads reports. So, for example, if the limit is 30 campaigns in your plan, you can create a maximum of 30 reports with one campaign per report. If you reach the limit, you can delete any report created to create a different one afterwards.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '30',
                        },
                        {
                            text: '30',
                        },
                        {
                            text: '30',
                        },
                        {
                            text: '30',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Number of Mentions'),
                            message: i18n.t(
                                'The maximum number of mentions that can be tracked per month, across all your queries.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: 1000,
                        },
                        {
                            text: 3000,
                        },
                        {
                            text: 6000,
                        },
                        {
                            text: 12000,
                        },
                    ],
                },
            ],
        },
        {
            id: 'PublishSchedule',
            title: i18n.t('Publish & Schedule'),
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('Social Networks Supported'),
                            message: i18n.t(
                                'All the social media channels available on Swonkie to post or schedule content.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/twitter.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/googleStore.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/blog.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tiktok.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/twitter.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/googleStore.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/blog.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tiktok.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/twitter.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/googleStore.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/blog.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tiktok.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/twitter.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/googleStore.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/blog.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tiktok.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/twitter.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/googleStore.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/blog.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tiktok.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Social Profiles ( up to )'),
                            message: i18n.t(
                                'The number of social media profiles you can add per plan. A social profile is any social media page or account you manage. So, for example if you manage 4 Facebook Business pages, 5 Twitter accounts and 2 Linkedin pages, that would be 11 social profiles in total.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '10',
                        },
                        {
                            text: '15',
                        },
                        {
                            text: '30',
                        },
                        {
                            text: '50',
                        },
                        {
                            text: '100',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Scheduling ( up to )'),
                            message: i18n.t(
                                'The maximum number of posts that can be scheduled monthly.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '1 000',
                        },
                        {
                            text: '1 000',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                        {
                            text: '1 000',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                        {
                            text: '1 000',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                        {
                            text: '1 000',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Scheduling time ( up to )'),
                            message: i18n.t(
                                'The maximum amount of time your content can be scheduled in advance.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: i18n.t('{{number}} Months', { number: 2 }),
                        },
                        {
                            text: i18n.t('{{number}} Months', { number: 6 }),
                        },
                        {
                            text: i18n.t('{{number}} Months', { number: 12 }),
                        },
                        {
                            text: i18n.t('{{number}} Years', { number: 2 }),
                        },
                        {
                            text: i18n.t('{{number}} Years', { number: 2 }),
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Twitter Posting Limit'),
                            message: i18n.t(
                                'The maximum number of tweets you can publish, per month, on each Twitter account.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: 50,
                        },
                        {
                            text: '3 000',
                        },
                        {
                            text: '3 000',
                        },
                        {
                            text: '3 000',
                        },
                        {
                            text: '3 000',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Boosted Posts'),
                            message: i18n.t(
                                'The ability to promote content when you create your publications, with all the options you need for your ads to reach the right audience.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Image Upload ( up to )'),
                            message: i18n.t(
                                'The maximum size per type of file that can be uploaded in one post.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '10 MB',
                        },
                        {
                            text: '20 MB',
                        },
                        {
                            text: '25 MB',
                        },
                        {
                            text: '25 MB',
                        },
                        {
                            text: '25 MB',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Video Upload ( up to )'),
                            message: i18n.t(
                                'The maximum size per type of file that can be uploaded in one post.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '25 MB',
                        },
                        {
                            text: '50 MB',
                        },
                        {
                            text: '99 MB',
                        },
                        {
                            text: '99 MB',
                        },
                        {
                            text: '99 MB',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('SEO Analyse'),
                            message: i18n.t(
                                'Feature available for Wordpress, Blogspot and Tumblr to analyze the SEO of the article for the blog.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '1 000',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '1 000',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '1 000',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '1 000',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '1 000',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('RSS Feeds (up to )'),
                            message: i18n.t(
                                'The ability to add any RSS Feeds on Swonkie to load articles to be automatically shared on your social media channels.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '2',
                        },
                        {
                            text: '10',
                        },
                        {
                            text: '15',
                        },
                        {
                            text: '20',
                        },
                        {
                            text: '25',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('RSS Update Time ( up to )'),
                            message: i18n.t(
                                'The period of time that your RSS Feed on Swonkie can be updated directly from the original site, to load more articles.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '120 mins',
                        },
                        {
                            text: '60 mins',
                        },
                        {
                            text: '30 mins',
                        },
                        {
                            text: '15 mins',
                        },
                        {
                            text: '5 Mins',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Channels ( up to )'),
                            message: i18n.t(
                                'Channels are like workspaces. You can create as many as you like to easily organize your social media profiles, by client, brand or project. It helps you to easily select your social media profiles accross all areas of Swonkie.'
                            ),
                        },
                    ],
                    content: [
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Queued Posts'),
                            message: i18n.t(
                                'Queued posts are different from scheduled posts. Queued posts are useful to define previously scheduling times and sending publications for those scheduling intervals according to the rules created such as days, hours and time intervals. You can create multiple queues on the same channel.'
                            ),
                        },
                    ],
                    content: [
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Export Calendar ( pdf, ppt)'),
                            message: i18n.t(
                                'The ability to export your calendar with all the details of the scheduled posts ready to be sent to your client.'
                            ),
                        },
                    ],
                    content: [
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Post Calendar Preview'),
                            message: i18n.t(
                                'See all the scheduled posts in one single timeline, in the exact format that you will have in each of the social networks.'
                            ),
                        },
                    ],
                    content: [
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('UTM Tag Builder'),
                            message: i18n.t(
                                'Add your tags to the link by filling in the UTM parameters before sending the link on your post.'
                            ),
                        },
                    ],
                    content: [
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Stock Photo Library'),
                            message: i18n.t(
                                'Connect with pixabay to get tons of free images ready to be shared on your posts.'
                            ),
                        },
                    ],
                    content: [
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'TeamWorkflow',
            title: i18n.t('Team Workflow'),
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('Team Management'),
                            message: i18n.t(
                                'Invite additional users to your team to be part of your workflow. All users can have different roles in the team.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Team Members ( up to )'),
                            message: i18n.t(
                                'The maximum number of team members that can be added on the main account per plan.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '3',
                        },
                        {
                            text: '5',
                        },
                        {
                            text: '10',
                        },
                        {
                            text: '15',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Approval Workflow'),
                            message: i18n.t(
                                'A team member can request approval of their post, which will be directed to the Posts Workflow Area. Both the account owner and users with permission to do so will have access to review and approve this content.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Unified Calendar'),
                            message: i18n.t(
                                'View different content made by different users on the same calendar.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'ReportsInsights',
            title: i18n.t('Reports & Insights'),
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('Social Networks Supported'),
                            message: i18n.t(
                                'All the social media networks available on Swonkie to get reports.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/youtube.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/googleStore.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/youtube.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/googleStore.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/youtube.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/googleStore.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/youtube.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/googleStore.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/youtube.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/googleStore.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Type of Report'),
                            message: i18n.t(
                                'The type of reports available for each plan. The basic reports only contain the main KPI\'s without any details. Just a simple overview. To get all the insights, users must get the advanced reports.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: i18n.t('Basic'),
                        },
                        {
                            text: i18n.t('Advanced'),
                        },
                        {
                            text: i18n.t('Advanced'),
                        },
                        {
                            text: i18n.t('Advanced'),
                        },
                        {
                            text: i18n.t('Advanced'),
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Number of Reports Saved'),
                            message: i18n.t(
                                'The number of reports that can be saved in the report list. The reports are customizable and you can save different layouts.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/infinite.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Reports Export ( pdf, ppt, csv )'),
                            message: i18n.t(
                                'The ability to extract your reports in the available formats such as pdf, powerpoint or csv.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Historical Data ( up to )'),
                            message: i18n.t(
                                'The maximum period of time that your analytic data is saved and available in the reports.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: i18n.t('{{number}} Months', { number: 1 }),
                        },
                        {
                            text: i18n.t('{{number}} Months', { number: 3 }),
                        },
                        {
                            text: i18n.t('{{number}} Months', { number: 6 }),
                        },
                        {
                            text: i18n.t('{{number}} Months', { number: 9 }),
                        },
                        {
                            text: i18n.t('{{number}} Months', { number: 12 }),
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Scheduling Reports'),
                            message: i18n.t(
                                'The possibility to automate the sending of reports to the clients or other team members.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: i18n.t('Monthly'),
                        },
                        {
                            text: i18n.t('Monthly'),
                        },
                        {
                            text: i18n.t('Fortnightly'),
                        },
                        {
                            text: i18n.t('Fortnightly'),
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Customizable Reports'),
                            message: i18n.t(
                                'All the reports can be customized. The selection of metrics can be changed at any time and your company information, such as logo or name, can be added on the exportable layout.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Non-labelled Reports'),
                            message: i18n.t(
                                'All the reports do not include the Swonkie logo mark.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'AdsManagement',
            title: i18n.t('Ads Management'),
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('Social Networks Supported'),
                            message: i18n.t(
                                'All the social media networks available on Swonkie for creating ads reports.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Number of Campaigns'),
                            message: i18n.t(
                                'The maximum number of ads campaigns that can be selected to create different ads reports. So, for example, if the limit is 30 campaigns in your plan, you can create a maximum of 30 reports with one campaign per report. If you reach the limit, you can delete any report created to create a different one afterwards.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '30',
                        },
                        {
                            text: '30',
                        },
                        {
                            text: '30',
                        },
                        {
                            text: '30',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Ads Overview'),
                            message: i18n.t(
                                'The ability to view the performance of ads per business account, globally. Gives you the main KPI\'s on your account´s performance, including all the campaigns together, without differentiating any.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Ads Campaigns'),
                            message: i18n.t(
                                'The ability to view your ads campaigns individually and in full detail per campaign. The most complete ads campaign report on the market.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'CompetitionBenchmarking',
            title: i18n.t('Competition & Benchmarking'),
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('Social Networks Supported'),
                            message: i18n.t(
                                'All the social media networks available on Swonkie to track competitor\'s activity.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t(
                                'Number of Competitors Social Profile'
                            ),
                            message: i18n.t(
                                'The number of your competitors\' social media profiles that you can add to each plan. A social profile is any social media page or account that you manage. So, for example, if you add 1 Facebook Business page and 1 twitter profile, that would be 2 social profiles in total.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '2',
                        },
                        {
                            text: '5',
                        },
                        {
                            text: '10',
                        },
                        {
                            text: '20',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Tracking in Real Time'),
                            message: i18n.t(
                                'The ability to track your competitors\' social media posts in real time and get them in a single feed where everything can be viewed on the same screen. You can add some specific alerts to track their activity as well.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Viral Alerts Performance'),
                            message: i18n.t(
                                'The ability to get alerts in real time on the platform or directly in your email when a competitor is having a viral post. Never miss one again.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t(
                                'Supported Competitors Reports Profiles'
                            ),
                            message: i18n.t(
                                'All the social media networks available on Swonkie to track competitors performance, creating comparative reports.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Competitors Reports'),
                            message: i18n.t(
                                'The ability to create and save competitors reports.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Export Competitors Reports'),
                            message: i18n.t(
                                'The ability to extract competitors reports, in the available formats such as pdf, powerpoint or csv.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        /*{
            title: i18n.t('Influence Marketing'),
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('Social Networks Supported'),
                            message: i18n.t('The social media networks available on Swonkie to track the performance of influencers.')
                        }
                    ],
                    content: [
                        {
                            text: '-'
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg')
                                }
                            ]
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg')
                                }
                            ]
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg')
                                }
                            ]
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg')
                                }
                            ]
                        }
                    ]
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Number of Searches ( up to )'),
                            message: i18n.t('The maximum number of searches per month that can be done. If you search for a profile and click on it, it will count as one search. However, if you click on it in the same month, it will not count as a new search. As you can understand, this area gathers tons of data and we need to set limits.')
                        }
                    ],
                    content: [
                        {
                            text: '5'
                        },
                        {
                            text: '20'
                        },
                        {
                            text: '40'
                        },
                        {
                            text: '75'
                        },
                        {
                            text: '150'
                        }
                    ]
                }
            ]
        },*/
        {
            id: 'CommunityManagementInbox',
            title: i18n.t('Community Management & Inbox'),
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('Social Networks Supported'),
                            message: i18n.t(
                                'All the social media channels available on Swonkie to view and manage content.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/blog.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/blog.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/blog.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/blog.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/blog.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/linkedin.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Reply, Manage and Export Comments'),
                            message: i18n.t(
                                'The ability to view the content already published in your feed and manage its engagement.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Comments Approval System'),
                            message: i18n.t(
                                'The ability to send a response to a comment for approval by any team member.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Inbox Social Networks Supported'),
                            message: i18n.t(
                                'All the social media channels available on Swonkie to reply to private messages.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Integrations'),
                            message: i18n.t(
                                'Integration with RD Station to make it easy to send the potential leads to your automation rules. We are working on more integrations for this area in the future.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'SocialListening',
            title: i18n.t('Social Listening'),
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('Social Networks Supported'),
                            message: i18n.t(
                                'The number of keywords or group of keywords that can be monitored, such as your competitors, a set of industry keywords, hashtags or specific handles.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/youtube.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/reddit.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/internet.svg'),
                                },
                            ],
                        },
                        {
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/youtube.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/reddit.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/internet.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/youtube.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/reddit.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/internet.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/facebook.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/instagram.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/youtube.svg'),
                                },
                                /*{
                                    icon: require('./../../resources/icons/smallLogos/pinterest.svg')
                                },*/
                                {
                                    icon: require('./../../resources/icons/smallLogos/reddit.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/tumblr.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/wordpress.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/internet.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Projects'),
                            message: i18n.t(
                                'The number of keywords or group of keywords that can be monitored, such as your competitors, a set of industry keywords, hashtags or specific handles.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '2',
                        },
                        {
                            text: '4',
                        },
                        {
                            text: '8',
                        },
                        {
                            text: '16',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Mentions'),
                            message: i18n.t(
                                'The maximum number of mentions that can be tracked per month, across all your queries.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: 1000,
                        },
                        {
                            text: 3000,
                        },
                        {
                            text: 6000,
                        },
                        {
                            text: 12000,
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Refresh Rate'),
                            message: i18n.t(
                                'How often are new mentions sought (this time may vary according to the volume of mentions).'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '720 min',
                        },
                        {
                            text: '360 min',
                        },
                        {
                            text: '360 min',
                        },
                        {
                            text: '360 min',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Stored Mentions per Project'),
                            message: i18n.t(
                                'The maximum number of results stored per project.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '500',
                        },
                        {
                            text: '1500',
                        },
                        {
                            text: '3000',
                        },
                        {
                            text: '8000',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Historical Project ( up to )'),
                            message: i18n.t(
                                'The maximum period of time that your project is saved.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: i18n.t('{{number}} Months', { number: 3 }),
                        },
                        {
                            text: i18n.t('{{number}} Months', { number: 6 }),
                        },
                        {
                            text: i18n.t('{{number}} Months', { number: 9 }),
                        },
                        {
                            text: i18n.t('{{number}} Year', { number: 1 }),
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Sentiment analysis'),
                            message: i18n.t(
                                'Sentiment analysis on the topics you are monitoring.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Reports & analytics'),
                            message: i18n.t(
                                'The ability to generate performance reports about your monitored topics.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Dashboard in real time'),
                            message: i18n.t(
                                'The ability to generate a dashboard on an exclusive screen.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'Support',
            title: i18n.t('Support'),
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('E-mail or Chat'),
                            message: i18n.t(
                                'If you\'re in love with our features so far, it gets a little better with our support. Fast and helpful support via email or chat. We are always available for any technical questions about the platform. However, if there are no doubts, you can simply leave us a hello, we would love to hear from you.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '16/7',
                        },
                        {
                            text: '16/7',
                        },
                        {
                            text: '16/7',
                        },
                        {
                            text: '16/7',
                        },
                        {
                            text: '16/7',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Demo Included'),
                            message: i18n.t(
                                'This means that your plan may or may not have a personalized demo to show you the features in detail by an Account Manager, in an online meeting. Only available in Portuguese, English and Spanish. If your plan doesn\'t include a demo, here\'s the price to get one.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '50€',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Onboarding Training'),
                            message: i18n.t(
                                'This means that your plan may or may not have a personalized onboarding training for your entire team, to show the features in detail by an Account Manager, in an online meeting. Only available in Portuguese, English and Spanish. If your plan doesn\'t include an onboarding training session, here\'s the price to get one.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '100€',
                        },
                        {
                            text: '100€',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Dedicated Account Manager'),
                            message: i18n.t(
                                'Access to a dedicated Account Manager for topics that cannot be resolved via chat or email, to whom you can call for any question.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'Security',
            title: i18n.t('Security'),
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('Security notifications'),
                            message: i18n.t(
                                'Email alerts to keep you aware of any suspicious account activity.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Two Factor Authentication'),
                            message: i18n.t(
                                'An extra layer of security to your account.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
        {
            id: 'Andie',
            title: 'ANDIE',
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('ANDIE'),
                            message: i18n.t(
                                'ANDIE is Swonkie\'s AI-powered assistant that takes your social media content, community, and performance to the next level. Unlock the potential of AI with ANDIE.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('ANDIE Credits'),
                            message: i18n.t(
                                'ANDIE Credits are used for you to perform actions with ANDIE, such as improving and fixing text, suggesting hashtags or emojis, or composing entire posts.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '100',
                        },
                        {
                            text: '500',
                        },
                        {
                            text: '1000',
                        },
                        {
                            text: '1500',
                        },
                        {
                            text: '2500',
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Publish & Schedule'),
                            message: i18n.t(
                                'Harness the power of ANDIE in content publishing to enhance your posts or even create entirely new content with ease.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Planning'),
                            message: '',
                        },
                    ],
                    content: [
                        {
                            text: i18n.t('Comming Soon'),
                        },
                        {
                            text: i18n.t('Comming Soon'),
                        },
                        {
                            text: i18n.t('Comming Soon'),
                        },
                        {
                            text: i18n.t('Comming Soon'),
                        },
                        {
                            text: i18n.t('Comming Soon'),
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Social Listening'),
                            message: '',
                        },
                    ],
                    content: [
                        {
                            text: i18n.t('Comming Soon'),
                        },
                        {
                            text: i18n.t('Comming Soon'),
                        },
                        {
                            text: i18n.t('Comming Soon'),
                        },
                        {
                            text: i18n.t('Comming Soon'),
                        },
                        {
                            text: i18n.t('Comming Soon'),
                        },
                    ],
                },
            ],
        },
        {
            id: 'Integrations',
            title: i18n.t('Integrations'),
            head: [
                {
                    title: 'Starter',
                },
                {
                    title: 'Friendly',
                },
                {
                    title: 'Lover',
                },
                {
                    title: 'Pro',
                },
                {
                    title: 'Master',
                },
            ],
            body: [
                {
                    collapseButton: [
                        {
                            title: i18n.t('Supported Integrations Available'),
                            message: i18n.t(
                                'The systems that are integrated into Swonkie to help you with your social media activity.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: ' ',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/Slack_Technologies_Logo.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/google-drive-logo.svg'),
                                },
                                {
                                    icon: require('./../../resources/icons/smallLogos/rd_station_cor.svg'),
                                },
                            ],
                        },
                    ],
                },
                {
                    collapseButton: [
                        {
                            title: i18n.t('Reports API'),
                            message: i18n.t(
                                'The ability to integrate the Swonkie API to get data from social media channels directly to your system.'
                            ),
                        },
                    ],
                    content: [
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                        },
                        {
                            text: '-',
                            icons: [
                                {
                                    icon: require('./../../resources/icons/smallLogos/checked.svg'),
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
    questions: [
        {
            question: i18n.t('How does the 14-day free trial work?'),
            answer: i18n.t(
                'After signing up, you instantly get free access to all of our plans for 14 days. You don\'t have to pay anything and if you choose not to continue, you can avoid charges by downgrading or cancelling at any time before your trial period ends. However, we’re confident you’ll love it.'
            ),
        },
        {
            question: i18n.t('What happens at the end of the free trial?'),
            answer: i18n.t(
                'At the end of your trial, regular billing begins and you\'ll be charged but, as we said, you can cancel your account at any time during the trial so you won´t be charged.'
            ),
        },
        {
            question: i18n.t('Will I be notified before my free trial ends?'),
            answer: i18n.t(
                'Yes, you\'ll receive an email notification to warn you. You can also cancel any time during your free trial to avoid any charges. Cancelling your account is free. Be aware that, by any problem, that include emailing blocked, servers constrangiments or any cause, you can’t receive this email. We advise you always see your spam as well.'
            ),
        },
        {
            question: i18n.t('Can I upgrade or downgrade my plan at any time?'),
            answer: i18n.t(
                'Yes, you can change it anytime. If you want to upgrade to a higher plan ( we’ll be happy with that, you are growing ), we’ll calculate the difference and charge you a pro-rated amount for the current billing period. You’ll move to the new plan right after you upgrade. If you’re downgrading to a lower plan ( we´ll be sad, but we understand ), you’ll move to the lower plan and extend a pro-rated period on your billing.'
            ),
        },
        {
            question: i18n.t('Can I cancel my subscription?'),
            answer: i18n.t(
                'Yes, if you pick monthly billing then the subscription is month-to-month, renewed automatically. However there\'s no commitment and you can cancel anytime. If you pick annual billing, you\'re committed for the next 12 months (we do not offer refunds). The annual subscription is pre-paid for one year with a discount of up to 15% on your social media management cost. Please keep in mind that we do not store historical data for discontinued accounts, so you will lose all your data when your account expires.'
            ),
        },
        {
            question: i18n.t('What’s your refund policy?'),
            answer: i18n.t(
                'We do not offer refunds except on certain situations. Please check |swonkie.com/terms-conditions|, the point 4.3, refunds. Please contact us if you have any questions or need assistance. |sayhello@swonkie.com|.'
            ),
            url: [
                `${Config.host}${currentLanguage}/terms-conditions`,
                'mailto:sayhello@swonkie.com',
            ],
        },
        {
            question: i18n.t('What payment options do you offer?'),
            answer: i18n.t(
                'You can pay via credit card (Visa, Mastercard, and some more options). No contracts or commitments necessary and you can cancel at any time (without being refunded).'
            ),
        },
        {
            question: i18n.t('Can I pay by manual invoice?'),
            answer: i18n.t(
                'We offer the option to be invoiced for your social media management cost on our Friendly, Lover, PRO or Master plans. Please contact us to request our bank transfer information at |billing@swonkie.com|. To cover administrative costs, manual invoices are available only for annual plans.'
            ),
            url: ['mailto:billing@swonkie.com'],
        },
        {
            question: i18n.t('How do the annual plans work?'),
            answer: i18n.t(
                'When you sign up for any of our paid annual plans, you can save 15% per year compared to our monthly plans. Annual plans are billed annually as a one-time payment and will automatically renew unless cancelled.'
            ),
        },
        {
            question: i18n.t('Will I be charged VAT?'),
            answer: i18n.t(
                'If you are an individual, and\n - you are located in the European Union - the tax of Portugal (Portugal HQ) is applied; \n - you are located outside the European Union - the tax of Portugal (Portugal HQ) is applied; \n - you are located in Portugal - the tax of Portugal is applied. ( Continental Portugal: 23% | Madeira: 22% | Azores: 16% ) \n\n If you are a company, and \n - you are located in the European Union and you have provided a valid VAT (enterprise) number - no tax is applied; \n - you are located outside the European Union and you have provided a valid VAT (enterprise) number - no tax is applied; \n - you are located in Portugal - the tax of Portugal is applied. ( Continental Portugal: 23% | Madeira: 22% | Azores: 16% )'
            ),
        },
        {
            question: i18n.t('What kind of support do you offer?'),
            answer: i18n.t(
                'Our Support team works 7 days a week with an average response time of 5 minutes, during the weekend it can be 30 minutes on average. We do not differentiate the type of support provided by the plan you paid for. Support is the same for all of our clients. We support you through our online chat or via email at |sayhello@swonkie.com|.'
            ),
            url: ['mailto:sayhello@swonkie.com'],
        },
        {
            question: i18n.t('Can I get a demo?'),
            answer: i18n.t(
                'We’d love it if you asked us for a demo. It will be a pleasure to have one of our Key Account Managers in touch with you and better understand your needs. During your trial period you will have a pop-up to request your demo. If you prefer click |here|.'
            ),
            url: [`${Config.host}${currentLanguage}/contact`],
        },
        {
            question: i18n.t('What is a social profile?'),
            answer: i18n.t(
                'A social profile is any social media page or account you manage. So, for example, if you manage 4 Facebook Business pages, 5 Twitter accounts, and 2 Linkedin pages, that would be 11 social profiles total.'
            ),
        },
        {
            question: i18n.t('What kind of reports do you provide?'),
            answer: i18n.t(
                'Organic and paid media reports. You will love it. For each Facebook page, Twitter profile, Instagram profile, LinkedIn company page, YouTube Channel and Google My Business added, on report’s area we will give you the best reports on the market. The paid media is also available, for Facebook page and Instagram profile. Get a sample of our reports |here|. You can download your reports whenever you want.'
            ),
            url: [url],
        },
        {
            question: i18n.t(
                'How can I make a complaint, suggestion, or compliment?'
            ),
            answer: i18n.t(
                'You can use our chat or send an email to |sayhello@swonkie.com| to make a complaint, suggestion or compliment'
            ),
            url: [
                'mailto:sayhello@swonkie.com',
                'https://www.livroreclamacoes.pt/',
            ],
        },
    ],
    aboutUsCategories: [
        {
            leftText: i18n.t('Thankful') + ' ' + i18n.t('Humanity'),
            rightText:
                '|' +
                i18n.t('Honesty') +
                '| ' +
                i18n.t('Diversity') +
                ' ' +
                i18n.t('Curiosity') +
                ' ' +
                i18n.t('Passion') +
                ' ' +
                i18n.t('Empathy'),
        },
        {
            leftText: i18n.t('Humanity') + ' ' + i18n.t('Honesty'),
            rightText:
                '|' +
                i18n.t('Diversity') +
                '| ' +
                i18n.t('Curiosity') +
                ' ' +
                i18n.t('Passion') +
                ' ' +
                i18n.t('Empathy') +
                ' ' +
                i18n.t('Focused'),
        },
        {
            leftText: i18n.t('Honesty') + ' ' + i18n.t('Diversity'),
            rightText:
                '|' +
                i18n.t(i18n.t('Curiosity')) +
                '| ' +
                i18n.t('Passion') +
                ' ' +
                i18n.t('Empathy') +
                ' ' +
                i18n.t('Focused') +
                ' ' +
                i18n.t('Respect'),
        },
        {
            leftText: i18n.t('Diversity') + ' ' + i18n.t(i18n.t('Curiosity')),
            rightText:
                '|' +
                i18n.t(i18n.t('Passion')) +
                '| ' +
                i18n.t('Empathy') +
                ' ' +
                i18n.t('Focused') +
                ' ' +
                i18n.t('Respect') +
                ' ' +
                i18n.t('Ambition'),
        },
        {
            leftText: i18n.t('Curiosity') + ' ' + i18n.t(i18n.t('Passion')),
            rightText:
                '|' +
                i18n.t('Empathy') +
                '| ' +
                i18n.t('Focused') +
                ' ' +
                i18n.t('Respect') +
                ' ' +
                i18n.t('Ambition') +
                ' ' +
                i18n.t('No-Ego'),
        },
        {
            leftText: i18n.t('Passion') + ' ' + i18n.t('Empathy'),
            rightText:
                '|' +
                i18n.t('Focused') +
                '| ' +
                i18n.t('Respect') +
                ' ' +
                i18n.t('Ambition') +
                ' ' +
                i18n.t('No-Ego') +
                ' ' +
                i18n.t('Humility'),
        },
        {
            leftText: i18n.t('Empathy') + ' ' + i18n.t('Focused'),
            rightText:
                '|' +
                i18n.t('Respect') +
                '| ' +
                i18n.t('Ambition') +
                ' ' +
                i18n.t('No-Ego') +
                ' ' +
                i18n.t('Humility') +
                ' ' +
                i18n.t('Transparency'),
        },
        {
            leftText: i18n.t('Focused') + ' ' + i18n.t('Respect'),
            rightText:
                '|' +
                i18n.t('Ambition') +
                '| ' +
                i18n.t('No-Ego') +
                ' ' +
                i18n.t('Humility') +
                ' ' +
                i18n.t('Transparency'),
        },
        {
            leftText: i18n.t('Respect') + ' ' + i18n.t('Ambition'),
            rightText:
                '|' +
                i18n.t('No-Ego') +
                '| ' +
                i18n.t('Humility') +
                ' ' +
                i18n.t('Transparency') +
                ' ' +
                i18n.t('Full Engagement'),
        },
        {
            leftText: i18n.t('Ambition') + ' ' + i18n.t('No-Ego'),
            rightText:
                '|' +
                i18n.t('Humility') +
                '| ' +
                i18n.t('Transparency') +
                ' ' +
                i18n.t('Full Engagement') +
                ' ' +
                i18n.t('Integrity'),
        },
        {
            leftText: i18n.t('No-Ego') + ' ' + i18n.t('Humility'),
            rightText:
                '|' +
                i18n.t('Transparency') +
                '| ' +
                i18n.t('Full Engagement') +
                ' ' +
                i18n.t('Integrity') +
                ' ' +
                i18n.t('Harmony'),
        },
        {
            leftText: i18n.t('Humility') + ' ' + i18n.t('Transparency'),
            rightText:
                '|' +
                i18n.t('Full Engagement') +
                '| ' +
                i18n.t('Integrity') +
                ' ' +
                i18n.t('Harmony') +
                ' ' +
                i18n.t('Agility') +
                ' ' +
                i18n.t('Loyalty'),
        },
        {
            leftText: i18n.t('Transparency') + ' ' + i18n.t('Full Engagement'),
            rightText:
                '|' +
                i18n.t('Integrity') +
                '| ' +
                i18n.t('Harmony') +
                ' ' +
                i18n.t('Agility') +
                ' ' +
                i18n.t('Loyalty') +
                ' ' +
                i18n.t('Gratitude'),
        },
        {
            leftText: i18n.t('Full Engagement') + ' ' + i18n.t('Integrity'),
            rightText:
                '|' +
                i18n.t('Harmony') +
                '| ' +
                i18n.t('Agility') +
                ' ' +
                i18n.t('Loyalty') +
                ' ' +
                i18n.t('Gratitude') +
                ' ' +
                i18n.t('Humanity'),
        },
        {
            leftText: i18n.t('Integrity') + ' ' + i18n.t('Harmony'),
            rightText:
                '|' +
                i18n.t('Agility') +
                '| ' +
                i18n.t('Loyalty') +
                ' ' +
                i18n.t('Gratitude') +
                ' ' +
                i18n.t('Humanity') +
                ' ' +
                i18n.t('Honesty'),
        },
        {
            leftText: i18n.t('Harmony') + ' ' + i18n.t('Agility'),
            rightText:
                '|' +
                i18n.t('Loyalty') +
                '| ' +
                i18n.t('Gratitude') +
                ' ' +
                i18n.t('Humanity') +
                ' ' +
                i18n.t('Honesty') +
                ' ' +
                i18n.t('Diversity'),
        },
        {
            leftText: i18n.t('Agility') + ' ' + i18n.t('Loyalty'),
            rightText:
                '|' +
                i18n.t('Gratitude') +
                '| ' +
                i18n.t('Humanity') +
                ' ' +
                i18n.t('Honesty') +
                ' ' +
                i18n.t('Diversity') +
                ' ' +
                i18n.t(i18n.t('Curiosity')),
        },
        {
            leftText: i18n.t('Loyalty') + ' ' + i18n.t('Gratitude'),
            rightText:
                '|' +
                i18n.t('Humanity') +
                '| ' +
                i18n.t('Honesty') +
                ' ' +
                i18n.t('Diversity') +
                ' ' +
                i18n.t(i18n.t('Curiosity')) +
                ' ' +
                i18n.t(i18n.t('Passion')),
        },
    ],
    positions: [
        {
            title: i18n.t('Costumer Support'),
            href: 'costumer-support',
            position: [
                {
                    title: i18n.t(
                        'Bilingual Customer Happiness Support ( English / Spanish )'
                    ),
                    type: i18n.t(i18n.t('Full-time')),
                    detail: {
                        title: i18n.t(
                            'Bilingual Customer Happiness Support ( English / Spanish )'
                        ),
                        message: i18n.t(
                            i18n.t(
                                'Full time - Vila Nova de Famalicão, Portugal'
                            )
                        ),
                        buttonText: i18n.t('Apply now'),
                        info: [
                            {
                                title: i18n.t('More about Swonkie'),
                                message: i18n.t(
                                    'At Swonkie we work every day with a focus on clients’ needs. We are a young and multidisciplinary team. A Startup with strong growth and scaling accross Europe and also to Brazil. \n\n We believe that it is people who really make a difference, they are the engine to challenge all the estabilished limits and successfully face any challenge. \n\n We don’t accept the status-quo of others and we seek to innovate everyday to be the best. \n\n To maintain this path, we are recruiting for our Customer Happiness Support team in Vila Nova de Famalicão ( Swonkie HQ ).'
                                ),
                            },
                            {
                                title: i18n.t('What’s your mission'),
                                message: i18n.t(
                                    '• Provide outstanding customer support and keep a pulse on the customer experience journey; \n\n • Keep a calm and calculated approach to critical situations where a quick response and resolution is important; \n\n • Handle inbound customer inquiries and support requests; \n\n • Communicate directly with customers to answer questions and address issues through emails, live chat and other channels; \n\n • Proactively reach out to customers that might need help; \n\n • Troubleshoot product issues and bugs from start to finish, work with the engineering team to escalate bugs and fix them in a timely manner; \n\n • Help new customers upgrade and upsell existing customers to the plan of their dreams; \n\n • Help analyze technical bugs, product requests and customer pain points; \n\n • Ability to work well with other departments and to manage customer expectations; \n\n • Willingness to go the extra-mile for each customer contact; \n\n • Work closely with sales to provide expertise and consultancy on our products, give the prospect a full understanding of the product and its capabilities; \n\n • Lead all internal trainings on product upgrades, new releases, and enhancements, provide the team with the latest platform updates on a regular basis; \n\n • Monitor client health metrics, detect \'sick\' clients and work with the Account Owners to implement an effective retention strategy to prevent loss; \n\n • Build the company’s brand with each customer interaction.'
                                ),
                            },
                            {
                                title: i18n.t(
                                    'What kind of super powers you must have'
                                ),
                                message: i18n.t(
                                    '• Obsessed by customer service; \n\n • Comfortable with calls and live demo, ready to answer any question or face any objection; \n\n • Problem solver by nature; \n\n • Strong ability to write and speak Spanish and English, another language would be a plus; \n\n • Social media addict; \n\n • Ability to multitask, prioritize, and manage time effectively; \n\n • Self-starter mentality with the ability to proactively get on with work; \n\n • A creative thinker, able to come up with innovative ideas and solutions; \n\n • A confident and clear communicator with excellent writing and presentation skills over email, social media, video conference, webinars, or in person; \n\n • Fluent in English and Spanish on a business level, additional language is an advantage; \n\n • Tons of energy, passion, humor, compassion, and enthusiasm.'
                                ),
                            },
                            {
                                title: i18n.t('What we offer'),
                                message: i18n.t(
                                    '• Salary, of course. We give you our best offer; \n\n • Work in Vila Nova de Famalicão (Swonkie HQ), in the countryside, away from big cities and traffic problems; \n\n • Gain incredible experience building a truly successful, global SaaS company with a dedicated, small team where you can have a huge impact; \n\n • 22 days of holidays, plus one bonus day for your birthday; \n\n • 15 days of remote work per year; \n\n • Annual Company Retreat; \n\n • A team with very friendly atmosphere; \n\n • Work in a scaling company with startup culture; \n\n • Pre natal voucher & Extra days of parental leave; \n\n • Sabbatical paid period after 5 years in the company.'
                                ),
                            },
                            {
                                title: i18n.t('Get our attention'),
                                message: i18n.t(
                                    'Introduce yourself to us as a colleague. Tell us what your future could be like here at Swonkie. \n We value authenticity, so be yourself, be creative, and take your time with the application. \n\n Tell us why you want this job. Tell us about. \n\n • Why you want to work in Customer Success. \n\n • Why you want to work at Swonkie and not somewhere else. \n\n • A description of a great customer experience you have had recently and why it was awesome.'
                                ),
                            },
                            {
                                title: i18n.t('Hiring timeline'),
                                message: i18n.t(
                                    'After submitting your application you can count on this timeline. \n\n • 14 days to review your application and give you feedback. \n\n If you are selected to move forward. \n\n • 4 weeks from start to finish (it can be more, depending on the scheduling availability during the process).'
                                ),
                            },
                        ],
                    },
                },
                {
                    title: i18n.t(
                        'Bilingual Customer Happiness Support ( French / Spanish )'
                    ),
                    type: i18n.t('Full-time'),
                    detail: {
                        title: i18n.t(
                            'Bilingual Customer Happiness Support ( French / Spanish )'
                        ),
                        message: i18n.t(
                            'Full time - Vila Nova de Famalicão, Portugal'
                        ),
                        buttonText: i18n.t('Apply now'),
                        info: [
                            {
                                title: i18n.t('More about Swonkie'),
                                message: i18n.t(
                                    'At Swonkie we work every day with a focus on clients’ needs. We are a young and multidisciplinary team. A Startup with strong growth and scaling accross Europe and also to Brazil. \n\n We believe that it is people who really make a difference, they are the engine to challenge all the estabilished limits and successfully face any challenge. \n\n We don’t accept the status-quo of others and we seek to innovate everyday to be the best. \n\n To maintain this path, we are recruiting for our Customer Happiness Support team in Vila Nova de Famalicão ( Swonkie HQ ).'
                                ),
                            },
                            {
                                title: i18n.t('What’s your mission'),
                                message: i18n.t(
                                    '• Provide outstanding customer support and keep a pulse on the customer experience journey; \n\n • Keep a calm and calculated approach to critical situations where a quick response and resolution is important; \n\n • Handle inbound customer inquiries and support requests; \n\n • Communicate directly with customers to answer questions and address issues through emails, live chat and other channels; \n\n • Proactively reach out to customers that might need help; \n\n • Troubleshoot product issues and bugs from start to finish, work with the engineering team to escalate bugs and fix them in a timely manner; \n\n • Help new customers upgrade and upsell existing customers to the plan of their dreams; \n\n • Help analyze technical bugs, product requests and customer pain points; \n\n • Ability to work well with other departments and to manage customer expectations; \n\n • Willingness to go the extra-mile for each customer contact; \n\n • Work closely with sales to provide expertise and consultancy on our products, give the prospect a full understanding of the product and its capabilities; \n\n • Lead all internal trainings on product upgrades, new releases, and enhancements, provide the team with the latest platform updates on a regular basis; \n\n • Monitor client health metrics, detect \'sick\' clients and work with the Account Owners to implement an effective retention strategy to prevent loss; \n\n • Build the company’s brand with each customer interaction.'
                                ),
                            },
                            {
                                title: i18n.t(
                                    'What kind of super powers you must have'
                                ),
                                message: i18n.t(
                                    '• Obsessed by customer service; \n\n • Comfortable with calls and live demo, ready to answer any question or face any objection; \n\n • Problem solver by nature; \n\n • Strong ability to write and speak Spanish and French, another language would be a plus; \n\n • Social media addict; \n\n • Ability to multitask, prioritize, and manage time effectively; \n\n • Self-starter mentality with the ability to proactively get on with work; \n\n • A creative thinker, able to come up with innovative ideas and solutions; \n\n • A confident and clear communicator with excellent writing and presentation skills over email, social media, video conference, webinars, or in person; \n\n • Fluent in French and Spanish on a business level, additional language is an advantage; \n\n • Tons of energy, passion, humor, compassion, and enthusiasm.'
                                ),
                            },
                            {
                                title: i18n.t('What we offer'),
                                message: i18n.t(
                                    '• Salary, of course. We give you our best offer; \n\n • Work in Vila Nova de Famalicão (Swonkie HQ), in the countryside, away from big cities and traffic problems; \n\n • Gain incredible experience building a truly successful, global SaaS company with a dedicated, small team where you can have a huge impact; \n\n • 22 days of holidays, plus one bonus day for your birthday; \n\n • 15 days of remote work per year; \n\n • Annual Company Retreat; \n\n • A team with very friendly atmosphere; \n\n • Work in a scaling company with startup culture; \n\n • Pre natal voucher & Extra days of parental leave; \n\n • Sabbatical paid period after 5 years in the company.'
                                ),
                            },
                            {
                                title: i18n.t('Get our attention'),
                                message: i18n.t(
                                    'Introduce yourself to us as a colleague. Tell us what your future could be like here at Swonkie. \n We value authenticity, so be yourself, be creative, and take your time with the application. \n\n Tell us why you want this job. Tell us about. \n\n • Why you want to work in Customer Success. \n\n • Why you want to work at Swonkie and not somewhere else. \n\n • A description of a great customer experience you have had recently and why it was awesome.'
                                ),
                            },
                            {
                                title: i18n.t('Hiring timeline'),
                                message: i18n.t(
                                    'After submitting your application you can count on this timeline. \n\n • 14 days to review your application and give you feedback. \n\n If you are selected to move forward. \n\n • 4 weeks from start to finish (it can be more, depending on the scheduling availability during the process).'
                                ),
                            },
                        ],
                    },
                },
            ],
        },
        {
            title: i18n.t('Sales'),
            href: 'sales',
            position: [
                {
                    title: i18n.t('Commercial Account Manager ( Europe )'),
                    type: i18n.t('Full-time'),
                    detail: {
                        title: i18n.t('Commercial Account Manager ( Europe )'),
                        message: i18n.t(
                            'Full time - Vila Nova de Famalicão, Portugal'
                        ),
                        buttonText: i18n.t('Apply now'),
                        info: [
                            {
                                title: i18n.t('More about Swonkie'),
                                message: i18n.t(
                                    'At Swonkie we work every day with a focus on clients’ needs. We are a young and multidisciplinary team. A Startup with strong growth and scaling accross Europe and also to Brazil. \n\n We believe that it is people who really make a difference, they are the engine to challenge all the estabilished limits and successfully face any challenge. \n\n We don’t accept the status-quo of others and we seek to innovate everyday to be the best. \n\n To maintain this path, we are recruiting for our Sales team in Vila Nova de Famalicão ( Swonkie HQ ).'
                                ),
                            },
                            {
                                title: i18n.t('What’s your mission'),
                                message: i18n.t(
                                    '• Contact prospective customers (outbound and inbound) regarding their need for a social media management solution via the internal sales process; \n\n • Full pipeline management; \n\n • Handle inbound customer inquiries and support requests; \n\n • Carry out in-depth discovery and analysis of prospects during the sales cycle; \n\n • Activate qualified but inactive trial leads into engaged trial users with a view to converting to subscription; \n\n • Understand clients’ needs and offering solutions and support; \n\n • Help prospects understand the competitive advantage and benefits of using a solution like Swonkie; \n\n • Negotiate skillfully where necessary; \n\n • Maintain an excellent relationship with current clients; \n\n • Manage, track and execute an effective and professional follow-up; \n\n • Work with your sales director to provide up to date and timely reporting on your numbers and qualitative feedback that is concise and can be used by the sales, marketing and product teams; \n\n • Ensure a positive customer experience with our prospects. They need to feel like a customer from day 1; \n\n • Collaborate with Customer Happiness Support to refer your new customers for an ongoing positive experience; \n\n • Organize your time efficiently, focusing on the highest priority and revenue generating activities to hit goals; \n\n • Bring creative ideas, strategies, and skills to promote our company’s values, unique culture and vision for the future.'
                                ),
                            },
                            {
                                title: i18n.t(
                                    'What kind of super powers you must have'
                                ),
                                message: i18n.t(
                                    '• It is important to have proven client facing experience, preferably sales or telesales experience in the B2B sector. We are also open to people who already have a strong social media knowledge and are interested in starting a sales career; \n\n • Strong interest in social media and marketing trends; \n\n • Passion for communication and relationship building; \n\n • Desire to meet and exceed measurable performance goals; \n\n • Ability to handle objections and demonstrate the value of solutions; \n\n • Strong sales instinct and excellent presentation & negotiation skills; \n\n • Fluent English on a business level, additional language is an advantage; \n\n • Availability to travel around Europe; \n\n • Last but not least, tons of energy, passion, humor and enthusiasm.'
                                ),
                            },
                            {
                                title: i18n.t('What we offer'),
                                message: i18n.t(
                                    '• Salary, of course. We give you our best offer; \n\n • Work in Vila Nova de Famalicão (Swonkie HQ), in the countryside, away from big cities and traffic problems; \n\n • Gain incredible experience building a truly successful, global SaaS company with a dedicated, small team where you can have a huge impact; \n\n • 22 days of holidays, plus one bonus day for your birthday; \n\n • 15 days of remote work per year; \n\n • Annual Company Retreat; \n\n • A team with very friendly atmosphere; \n\n • Work in a scaling company with startup culture; \n\n • Pre natal voucher & Extra days of parental leave; \n\n • Sabbatical paid period after 5 years in the company.'
                                ),
                            },
                            {
                                title: i18n.t('Get our attention'),
                                message: i18n.t(
                                    'Introduce yourself to us as a colleague. Tell us what your future could be like here at Swonkie. \n We value authenticity, so be yourself, be creative, and take your time with the application. \n\n   Tell us why you want this job. Tell us about. \n\n • Why you want to work in Sales. \n\n • Why you want to work at Swonkie and not somewhere else. \n\n • A description of a sales process that you had recently during a sale to a new client and why it was awesome.'
                                ),
                            },
                            {
                                title: i18n.t('Hiring timeline'),
                                message: i18n.t(
                                    'After submitting your application you can count on this timeline. \n\n • 14 days to review your application and give you feedback. \n\n If you are selected to move forward. \n\n • 4 weeks from start to finish (it can be more, depending on the scheduling availability during the process).'
                                ),
                            },
                        ],
                    },
                },
                {
                    title: i18n.t('Commercial Account Manager ( Spain )'),
                    type: i18n.t('Full-time'),
                    detail: {
                        title: i18n.t('Commercial Account Manager ( Spain )'),
                        message: i18n.t(
                            'Full time - Vila Nova de Famalicão, Portugal'
                        ),
                        buttonText: i18n.t('Apply now'),
                        info: [
                            {
                                title: i18n.t('More about Swonkie'),
                                message: i18n.t(
                                    'At Swonkie we work every day with a focus on clients’ needs. We are a young and multidisciplinary team. A Startup with strong growth and scaling accross Europe and also to Brazil. \n\n We believe that it is people who really make a difference, they are the engine to challenge all the estabilished limits and successfully face any challenge. \n\n We don’t accept the status-quo of others and we seek to innovate everyday to be the best. \n\n To maintain this path, we are recruiting for our Sales team in Vila Nova de Famalicão ( Swonkie HQ ).'
                                ),
                            },
                            {
                                title: i18n.t('What’s your mission'),
                                message: i18n.t(
                                    '• Contact prospective customers (outbound and inbound) regarding their need for a social media management solution via the internal sales process; \n\n • Full pipeline management; \n\n • Handle inbound customer inquiries and support requests; \n\n • Carry out in-depth discovery and analysis of prospects during the sales cycle; \n\n • Activate qualified but inactive trial leads into engaged trial users with a view to converting to subscription; \n\n • Understand clients’ needs and offering solutions and support; \n\n • Help prospects understand the competitive advantage and benefits of using a solution like Swonkie; \n\n • Negotiate skillfully where necessary; \n\n • Maintain an excellent relationship with current clients; \n\n • Manage, track and execute an effective and professional follow-up; \n\n • Work with your sales director to provide up to date and timely reporting on your numbers and qualitative feedback that is concise and can be used by the sales, marketing and product teams; \n\n • Ensure a positive customer experience with our prospects. They need to feel like a customer from day 1; \n\n • Collaborate with Customer Happiness Support to refer your new customers for an ongoing positive experience; \n\n • Organize your time efficiently, focusing on the highest priority and revenue generating activities to hit goals; \n\n • Bring creative ideas, strategies, and skills to promote our company’s values, unique culture and vision for the future.'
                                ),
                            },
                            {
                                title: i18n.t(
                                    'What kind of super powers you must have'
                                ),
                                message: i18n.t(
                                    '• It is important to have proven client facing experience, preferably sales or telesales experience in the B2B sector. We are also open to people who already have a strong social media knowledge and are interested in starting a sales career; \n\n • Strong interest in social media and marketing trends; \n\n • Passion for communication and relationship building; \n\n • Desire to meet and exceed measurable performance goals; \n\n • Ability to handle objections and demonstrate the value of solutions; \n\n • Strong sales instinct and excellent presentation & negotiation skills; \n\n • Fluent Spanish on a business level, additional language is an advantage; \n\n • Availability to travel around Europe; \n\n • Last but not least, tons of energy, passion, humor and enthusiasm.'
                                ),
                            },
                            {
                                title: i18n.t('What we offer'),
                                message: i18n.t(
                                    '• Salary, of course. We give you our best offer; \n\n • Work in Vila Nova de Famalicão (Swonkie HQ), in the countryside, away from big cities and traffic problems; \n\n • Gain incredible experience building a truly successful, global SaaS company with a dedicated, small team where you can have a huge impact; \n\n • 22 days of holidays, plus one bonus day for your birthday; \n\n • 15 days of remote work per year; \n\n • Annual Company Retreat; \n\n • A team with very friendly atmosphere; \n\n • Work in a scaling company with startup culture; \n\n • Pre natal voucher & Extra days of parental leave; \n\n • Sabbatical paid period after 5 years in the company.'
                                ),
                            },
                            {
                                title: i18n.t('Get our attention'),
                                message: i18n.t(
                                    'Introduce yourself to us as a colleague. Tell us what your future could be like here at Swonkie. \n We value authenticity, so be yourself, be creative, and take your time with the application. \n\n   Tell us why you want this job. Tell us about. \n\n • Why you want to work in Sales. \n\n • Why you want to work at Swonkie and not somewhere else. \n\n • A description of a sales process that you had recently during a sale to a new client and why it was awesome.'
                                ),
                            },
                            {
                                title: i18n.t('Hiring timeline'),
                                message: i18n.t(
                                    'After submitting your application you can count on this timeline. \n\n • 14 days to review your application and give you feedback. \n\n If you are selected to move forward. \n\n • 4 weeks from start to finish (it can be more, depending on the scheduling availability during the process).'
                                ),
                            },
                        ],
                    },
                },
                {
                    title: i18n.t('Commercial Account Manager ( France )'),
                    type: i18n.t('Full-time'),
                    detail: {
                        title: i18n.t('Commercial Account Manager ( France )'),
                        message: i18n.t(
                            'Full time - Vila Nova de Famalicão, Portugal'
                        ),
                        buttonText: i18n.t('Apply now'),
                        info: [
                            {
                                title: i18n.t('More about Swonkie'),
                                message: i18n.t(
                                    'At Swonkie we work every day with a focus on clients’ needs. We are a young and multidisciplinary team. A Startup with strong growth and scaling accross Europe and also to Brazil. \n\n We believe that it is people who really make a difference, they are the engine to challenge all the estabilished limits and successfully face any challenge. \n\n We don’t accept the status-quo of others and we seek to innovate everyday to be the best. \n\n To maintain this path, we are recruiting for our Sales team in Vila Nova de Famalicão ( Swonkie HQ ).'
                                ),
                            },
                            {
                                title: i18n.t('What’s your mission'),
                                message: i18n.t(
                                    '• Contact prospective customers (outbound and inbound) regarding their need for a social media management solution via the internal sales process; \n\n • Full pipeline management; \n\n • Handle inbound customer inquiries and support requests; \n\n • Carry out in-depth discovery and analysis of prospects during the sales cycle; \n\n • Activate qualified but inactive trial leads into engaged trial users with a view to converting to subscription; \n\n • Understand clients’ needs and offering solutions and support; \n\n • Help prospects understand the competitive advantage and benefits of using a solution like Swonkie; \n\n • Negotiate skillfully where necessary; \n\n • Maintain an excellent relationship with current clients; \n\n • Manage, track and execute an effective and professional follow-up; \n\n • Work with your sales director to provide up to date and timely reporting on your numbers and qualitative feedback that is concise and can be used by the sales, marketing and product teams; \n\n • Ensure a positive customer experience with our prospects. They need to feel like a customer from day 1; \n\n • Collaborate with Customer Happiness Support to refer your new customers for an ongoing positive experience; \n\n • Organize your time efficiently, focusing on the highest priority and revenue generating activities to hit goals; \n\n • Bring creative ideas, strategies, and skills to promote our company’s values, unique culture and vision for the future.'
                                ),
                            },
                            {
                                title: i18n.t(
                                    'What kind of super powers you must have'
                                ),
                                message: i18n.t(
                                    '• It is important to have proven client facing experience, preferably sales or telesales experience in the B2B sector. We are also open to people who already have a strong social media knowledge and are interested in starting a sales career; \n\n • Strong interest in social media and marketing trends; \n\n • Passion for communication and relationship building; \n\n • Desire to meet and exceed measurable performance goals; \n\n • Ability to handle objections and demonstrate the value of solutions; \n\n • Strong sales instinct and excellent presentation & negotiation skills; \n\n • Fluent French on a business level, additional language is an advantage; \n\n • Availability to travel around Europe; \n\n • Last but not least, tons of energy, passion, humor and enthusiasm.'
                                ),
                            },
                            {
                                title: i18n.t('What we offer'),
                                message: i18n.t(
                                    '• Salary, of course. We give you our best offer; \n\n • Work in Vila Nova de Famalicão (Swonkie HQ), in the countryside, away from big cities and traffic problems; \n\n • Gain incredible experience building a truly successful, global SaaS company with a dedicated, small team where you can have a huge impact; \n\n • 22 days of holidays, plus one bonus day for your birthday; \n\n • 15 days of remote work per year; \n\n • Annual Company Retreat; \n\n • A team with very friendly atmosphere; \n\n • Work in a scaling company with startup culture; \n\n • Pre natal voucher & Extra days of parental leave; \n\n • Sabbatical paid period after 5 years in the company.'
                                ),
                            },
                            {
                                title: i18n.t('Get our attention'),
                                message: i18n.t(
                                    'Introduce yourself to us as a colleague. Tell us what your future could be like here at Swonkie. \n We value authenticity, so be yourself, be creative, and take your time with the application. \n\n   Tell us why you want this job. Tell us about. \n\n • Why you want to work in Sales. \n\n • Why you want to work at Swonkie and not somewhere else. \n\n • A description of a sales process that you had recently during a sale to a new client and why it was awesome.'
                                ),
                            },
                            {
                                title: i18n.t('Hiring timeline'),
                                message: i18n.t(
                                    'After submitting your application you can count on this timeline. \n\n • 14 days to review your application and give you feedback. \n\n If you are selected to move forward. \n\n • 4 weeks from start to finish (it can be more, depending on the scheduling availability during the process).'
                                ),
                            },
                        ],
                    },
                },
                {
                    title: i18n.t('Commercial Account Manager ( LATAM )'),
                    type: i18n.t('Full-time'),
                    detail: {
                        title: i18n.t('Commercial Account Manager ( LATAM )'),
                        message: 'Full time - Remote',
                        buttonText: i18n.t('Apply now'),
                        info: [
                            {
                                title: i18n.t('More about Swonkie'),
                                message: i18n.t(
                                    'At Swonkie we work every day with a focus on clients’ needs. We are a young and multidisciplinary team. A Startup with strong growth and scaling accross Europe and also to Brazil. \n\n We believe that it is people who really make a difference, they are the engine to challenge all the estabilished limits and successfully face any challenge. \n\n We don’t accept the status-quo of others and we seek to innovate everyday to be the best. \n\n To maintain this path, we are recruiting for our Sales team to work remotely from a country in LATAM.'
                                ),
                            },
                            {
                                title: i18n.t('What’s your mission'),
                                message: i18n.t(
                                    '• Contact prospective customers (outbound and inbound) regarding their need for a social media management solution via the internal sales process; \n\n • Full pipeline management; \n\n • Handle inbound customer inquiries and support requests; \n\n • Carry out in-depth discovery and analysis of prospects during the sales cycle; \n\n • Activate qualified but inactive trial leads into engaged trial users with a view to converting to subscription; \n\n • Understand clients’ needs and offering solutions and support; \n\n • Help prospects understand the competitive advantage and benefits of using a solution like Swonkie; \n\n • Negotiate skillfully where necessary; \n\n • Maintain an excellent relationship with current clients; \n\n • Manage, track and execute an effective and professional follow-up; \n\n • Work with your sales director to provide up to date and timely reporting on your numbers and qualitative feedback that is concise and can be used by the sales, marketing and product teams; \n\n • Ensure a positive customer experience with our prospects. They need to feel like a customer from day 1; \n\n • Collaborate with Customer Happiness Support to refer your new customers for an ongoing positive experience; \n\n • Organize your time efficiently, focusing on the highest priority and revenue generating activities to hit goals; \n\n • Bring creative ideas, strategies, and skills to promote our company’s values, unique culture and vision for the future.'
                                ),
                            },
                            {
                                title: i18n.t(
                                    'What kind of super powers you must have'
                                ),
                                message: i18n.t(
                                    '• It is important to have proven client facing experience, preferably sales or telesales experience in the B2B sector. We are also open to people who already have a strong social media knowledge and are interested in starting a sales career; \n\n • Strong interest in social media and marketing trends; \n\n • Passion for communication and relationship building; \n\n • Desire to meet and exceed measurable performance goals; \n\n • Ability to handle objections and demonstrate the value of solutions; \n\n • Strong sales instinct and excellent presentation & negotiation skills; \n\n • Fluent in Brazilian Portuguese and Spanish on a business level, additional language is an advantage; \n\n • Availability to travel around LATAM; \n\n • Last but not least, tons of energy, passion, humor and enthusiasm.'
                                ),
                            },
                            {
                                title: i18n.t('What we offer'),
                                message: i18n.t(
                                    '• Salary, of course. We give you our best offer; \n\n • Work remotely from a country based in LATAM; \n\n • Gain incredible experience building a truly successful, global SaaS company with a dedicated, small team where you can have a huge impact; \n\n • 22 days of holidays, plus one bonus day for your birthday; \n\n • 15 days of remote work per year; \n\n • Annual Company Retreat; \n\n • A team with very friendly atmosphere; \n\n • Work in a scaling company with startup culture; \n\n • Pre natal voucher & Extra days of parental leave; \n\n • Sabbatical paid period after 5 years in the company.'
                                ),
                            },
                            {
                                title: i18n.t('Get our attention'),
                                message: i18n.t(
                                    'Introduce yourself to us as a colleague. Tell us what your future could be like here at Swonkie. \n We value authenticity, so be yourself, be creative, and take your time with the application. \n\n   Tell us why you want this job. Tell us about. \n\n • Why you want to work in Sales. \n\n • Why you want to work at Swonkie and not somewhere else. \n\n • A description of a sales process that you had recently during a sale to a new client and why it was awesome.'
                                ),
                            },
                            {
                                title: i18n.t('Hiring timeline'),
                                message: i18n.t(
                                    'After submitting your application you can count on this timeline. \n\n • 14 days to review your application and give you feedback. \n\n If you are selected to move forward. \n\n • 4 weeks from start to finish (it can be more, depending on the scheduling availability during the process).'
                                ),
                            },
                        ],
                    },
                },
            ],
        },
        {
            title: i18n.t('Development'),
            href: 'development',
            position: [
                {
                    title: i18n.t('Full Stack Developer'),
                    type: i18n.t('Full-time'),
                    detail: {
                        title: i18n.t('Full Stack Developer'),
                        message: i18n.t(
                            'Full time - Vila Nova de Famalicão, Portugal'
                        ),
                        buttonText: i18n.t('Apply now'),
                        info: [
                            {
                                title: i18n.t('More about Swonkie'),
                                message: i18n.t(
                                    'At Swonkie we work every day with a focus on clients’ needs. We are a young and multidisciplinary team. A Startup with strong growth and scaling accross Europe and also to Brazil. \n\n We believe that it is people who really make a difference, they are the engine to challenge all the established limits and successfully face any challenge. \n\n We don’t accept the status-quo of others and we seek to innovate everyday to be the best. \n\n To maintain this path, we are recruiting for our Development team in Vila Nova de Famalicão ( Swonkie HQ ).'
                                ),
                            },
                            {
                                title: i18n.t('What’s your mission'),
                                message: i18n.t(
                                    '• Write code - across all architectural layers (DBs, data APIs, application backends, frontends); \n\n • Solve challenging tasks; \n\n • Code reviews; \n\n • Maintain and optimize existing systems; \n\n • Discuss technical solutions with the development team and product team - we are part of the process since the feature specification (idea kickoff); \n\n • Team players with an agile mindset; \n\n • Suggest improvements; \n\n • Willingness to go the extra-mile for each new feature.'
                                ),
                            },
                            {
                                title: i18n.t(
                                    'What kind of super powers you must have'
                                ),
                                message: i18n.t(
                                    '• Mastered skills with HTML, CSS, JavaScript and PHP; \n\n • Significant experience with MySQL, Cassandra, MongoDB, Image and Video processing (with Imagick and FFMPEG); \n\n • Knowledge of React.js, SASS, Lumen, Docker and Git; \n\n • Experience with REST API and MVC; \n\n • Also appreciated Python and NodeJS; \n\n • Write clean, maintainable and testable code; \n\n • Ability to perform code reviews, create detailed plans and willingness to work collaboratively with a development team; \n\n • Excellent technical, troubleshooting and analytical skills.'
                                ),
                            },
                            {
                                title: i18n.t('What we offer'),
                                message: i18n.t(
                                    '• Salary, of course. We give you our best offer; \n\n • Work in Vila Nova de Famalicão (Swonkie HQ), in the countryside, away from big cities and traffic problems; \n\n • Gain incredible experience building a truly successful, global SaaS company with a dedicated, small team where you can have a huge impact; \n\n • 22 days of holidays, plus one bonus day for your birthday; \n\n • 15 days of remote work per year; \n\n • Annual Company Retreat; \n\n • A team with very friendly atmosphere; \n\n • Work in a scaling company with startup culture; \n\n • Pre natal voucher & Extra days of parental leave; \n\n • Sabbatical paid period after 5 years in the company.'
                                ),
                            },
                            {
                                title: i18n.t('Get our attention'),
                                message: i18n.t(
                                    'Introduce yourself to us as a colleague. Tell us what your future could be like here at Swonkie.\n We value authenticity, so be yourself, be creative, and take your time with the application.  \n\n  Tell us why you want this job. Tell us about. \n\n • Why you choose to work in development. \n\n • Why you want to work at Swonkie and not somewhere else. \n\n • A description of a bug issue you had recently and how you fixed it.'
                                ),
                            },
                            {
                                title: i18n.t('Hiring timeline'),
                                message: i18n.t(
                                    'After submitting your application you can count on this timeline. \n\n • 14 days to review your application and give you feedback. \n\n If you are selected to move forward. \n\n • 4 weeks from start to finish (it can be more, depending on the scheduling availability during the process).'
                                ),
                            },
                        ],
                    },
                },
            ],
        },
        {
            title: i18n.t('Marketing'),
            href: 'marketing',
            position: [
                {
                    title: i18n.t('Chief Growth Officer'),
                    type: i18n.t('Full-time'),
                    detail: {
                        title: i18n.t('Chief Growth Officer'),
                        message: i18n.t(
                            'Full time - Vila Nova de Famalicão, Portugal'
                        ),
                        buttonText: i18n.t('Apply now'),
                        info: [
                            {
                                title: i18n.t('More about Swonkie'),
                                message: i18n.t(
                                    'At Swonkie we work every day with a focus on clients’ needs. We are a young and multidisciplinary team. A Startup with strong growth and scaling accross Europe and also to Brazil. \n\n We believe that it is people who really make a difference, they are the engine to challenge all the established limits and successfully face any challenge. \n\n We don’t accept the status-quo of others and we seek to innovate everyday to be the best. \n\n To maintain this path, we are recruiting a Chief Growth Officer to work in Vila Nova de Famalicão ( Swonkie HQ ).'
                                ),
                            },
                            {
                                title: i18n.t('What’s your mission'),
                                message: i18n.t(
                                    '• Develop a strategic Marketing plan to drive key business metrics, deliver results and support future growth; \n\n • Deliver demand and lead generation strategy and tactics to drive customer acquisition, activation, retention and advocacy across all channels in support of Swonkie´s growth goals; \n\n • Drive the global campaign and content strategy to increase competitive differentiation and equip marketing and sales teams to build, accelerate and convert leads; \n\n • Develop, lead, and take ownership of the demand strategy for digital marketing; \n\n • Use detailed understanding of the buyer’s journey and marketing funnel stages to execute high performing B2B; \n\n • Work with Sales to develop high quality lead generation and an optimized sales funnel; \n\n • Set-up and run paid Facebook, Instagram, LinkedIn and Google campaigns; \n\n • Measure the performance of all aspects of marketing while constantly experimenting to improve and optimize performance across all channels including. SEO, SEM, social media; \n\n • Perform market research and build audiences for targeting; \n\n • Work collaboratively with all team members and company stakeholders.'
                                ),
                            },
                            {
                                title: i18n.t(
                                    'What kind of super powers you must have'
                                ),
                                message: i18n.t(
                                    '• 2+ years proven experience in running successful B2B campaigns with an annual budget of over €100k+; \n\n • Experience in running successful B2B Linkedin, Facebook, and Instagram campaigns; \n\n • Experience in running Email Marketing Campaigns; \n\n • Firm understanding of user experience and strong search engine optimization (SEO) and search engine marketing (SEM) skills; \n\n • Experience with optimizing paid media campaigns to achieve CPA and engagement goals; \n\n • Expert understanding of digital marketing KPIs, metrics, analytics and reporting methods; \n\n • Experience with the European market is an advantage; \n\n •Experience in identifying, capturing and nurturing qualified marketing leads through the sales funnel, from pre-pipeline all the way through demo booking; \n\n • Experience in defining and implementing user acquisition strategies; \n\n • Deep MS Excel or Google Sheets knowledge; \n\n • Experience in defining and implementing user acquisition strategies; \n\n • Data-driven, meticulous with a firm statistical understanding, well-organized; \n\n • Ability to forecast the marketing funnel and ensure that demand campaigns are measured and optimized to align with sales, budget, and marketing targets; \n\n • Fluent English on a business level, additional language is an advantage; \n\n • Must be comfortable with social media and community participation.'
                                ),
                            },
                            {
                                title: i18n.t('What we offer'),
                                message: i18n.t(
                                    '• Salary, of course. We give you our best offer; \n\n • Work in Vila Nova de Famalicão (Swonkie HQ), in the countryside, away from big cities and traffic problems; \n\n • Gain incredible experience building a truly successful, global SaaS company with a dedicated, small team where you can have a huge impact; \n\n • 22 days of holidays, plus one bonus day for your birthday; \n\n • 15 days of remote work per year; \n\n • Annual Company Retreat; \n\n • A team with very friendly atmosphere; \n\n • Work in a scaling company with startup culture; \n\n • Pre natal voucher & Extra days of parental leave; \n\n • Sabbatical paid period after 5 years in the company.'
                                ),
                            },
                            {
                                title: i18n.t('Get our attention'),
                                message: i18n.t(
                                    'Introduce yourself to us as a colleague. Tell us what your future could be like here at Swonkie. \n We value authenticity, so be yourself, be creative, and take your time with the application.  \n\n  Tell us why you want this job. Tell us about. \n\n • Why you are the perfect person for this job. \n\n • Why you want to work at Swonkie and not somewhere else. \n\n • A description of your best ad campaign ever, with the metrics, ROI and so on (no need to identify the brand).'
                                ),
                            },
                            {
                                title: i18n.t('Hiring timeline'),
                                message: i18n.t(
                                    'After submitting your application you can count on this timeline. \n\n • 14 days to review your application and give you feedback. \n\n If you are selected to move forward. \n\n • 4 weeks from start to finish (it can be more, depending on the scheduling availability during the process).'
                                ),
                            },
                        ],
                    },
                },
            ],
        },
    ],
    company: {
        title: i18n.t('Company'),
        buttons: [
            {
                text: i18n.t('About Us'),
                to: 'about',
                showNavbar: true,
            },
            {
                text: i18n.t('Careers'),
                to: 'careers',
                showNavbar: true,
            },
            {
                text: i18n.t('Press Room'),
                to: 'press-room',
                showNavbar: true,
            },
            {
                text: i18n.t('Contact Us'),
                to: 'contact',
                showNavbar: true,
            },
            {
                text: i18n.t('2020 Support'),
                to: Config.host + '2020',
                showNavbar: false,
            },
        ],
    },
    resources: {
        title: i18n.t('Resources'),
        buttons: [
            {
                text: i18n.t('Blog'),
                to:
                    Config.host +
                    'blog?utm_source=swonkie_homepage&utm_medium=organic&utm_campaign=rodape_swonkie',
                showNavbar: true,
            },
            {
                text: i18n.t('Holiday Calendar'),
                to: 'holiday-calendar',
            },
            {
                text: i18n.t('Calculator'),
                to: 'calculator',
            },
        ],
    },
    pressRoomArticles: [
        {
            image: require('./../../resources/images/pressRoom/Article1.webp'),
            article: 'shifter',
            title: 'Swonkie Academy: uma academia online sobre o digital',
            date: 'Jul 9, 2020',
        },
        {
            image: require('./../../resources/images/pressRoom/Article2.webp'),
            article: 'observador',
            title: 'Depois da América Latina, startup portuguesa que gere redes sociais ...',
            date: 'Apr 30, 2020',
        },
        {
            image: require('./../../resources/images/pressRoom/Article3.webp'),
            article: 'dinheirovivo',
            title: 'Swonkie quer nadar com os ‘tubarões sociais’ em Espanha',
            date: 'Apr 29, 2020',
        },
        {
            image: require('./../../resources/images/pressRoom/Article4.webp'),
            article: 'jornal economico',
            title: 'Swonkie, a plataforma de redes sociais que nasceu das apostas de futebol',
            date: 'Oct 16, 2018',
        },
        {
            article: 'exame',
            title: 'Swonkie chega no Brasil para poupar tempo das agências',
            date: 'Set 4, 2018',
        },
        {
            article: 'link to leaders',
            title: 'Swonkie: do Shark Tank português ao mercado ...',
            date: 'Set 14, 2018',
        },
    ],
    termsConditionPage: [
        {
            title: i18n.t('Terms & Conditions'),
            date: i18n.t('Last updated 10 July, 2023'),
            info: [
                {
                    title: i18n.t('1. Introduction'),
                    message: i18n.t(
                        'By reading these terms it means that you are interested on Swonkie, based in Vila Nova de Famalicao, Rua do Progresso nº 140, 2º andar, Fração BS, Vilarinho das Cambas, Portugal and we are glad with that. The following terms and conditions govern your access and use of the Swonkie website, |swonkie.com| and all subdomains included as well. \n\n These terms and conditions, also called “Agreement”, cover our rules and our policies to use the platform. \n\n By accessing and using our platform, you are accepting to be bound by the terms and conditions of this agreement. If you do not agree with these terms you should not access and use our platform. \n\n If these terms and conditions are considered an offer, acceptance is expressly limited to these terms. However you cannot reject our privacy policy and you must read it together, |here|. \n\n Swonkie reserves the right, at any time, to update, modify and replace any part or all of these terms and conditions. You will be notified when it occurs and continuing to use the platform shall constitute your agreement with those changes. \n\n Please check these Terms periodically for changes. Modifications will become effective upon the earlier of. \n\n i) your acceptance of the modified Terms; \n ii) your use of the Service with actual knowledge of the modified Terms; \n iii) thirty (30) days following our publication of the modified Terms through the Service. \n\n To notify you, Swonkie could make a banner notice to alert you or send an e-mail or a message through our platform. \n\n The last version is always updated on. |swonkie.com/terms&conditions|'
                    ),
                },
                {
                    title: i18n.t('2. Conditions of use'),
                    message: i18n.t(
                        'This agreement sets forth certain terms and conditions that apply to users. \n\n During this agreement Swonkie will provide to you and your authorized users the right to access and use our services for the conditions subscribed and paid. \n\n Swonkie reserves the right to change, suspend or discontinue the service at any time. This suspension may include availability of any feature, database or content, however this action will be reported on our platform in advance. \n\n User must guarantee the internet connection to connect, access and login on our platform. The user also needs to ensure that their equipment are compatible with our platform in terms of software and hardware. \n\n From time to time Swonkie may update the services, i.e add, modify, remove any functionality, feature or content. If at any time any supported platform (third-party api) cease to make their programs available to Swonkie on reasonable terms, Swonkie may cease to provide such features to you without entitling you to a refund, credit or any compensation. \n\n Swonkie may suspend your access to the services for abusive practices that degrade the performance of the services for you/or other swonkie’s customers. \n\n As a Swonkie user you will be exposed to third-party content such as information and images that might be offensive, inaccurate and inappropriate. Be aware that Swonkie does not control, review or do any check confirmation for this kind of content. \n\n Swonkie may also use Customer Content for the purpose of supporting and developing the Services, provided that when doing so, Swonkie shall only use Customer Content in an anonymized and aggregated way. \n\n You are solely responsible for the Customer Content that you or Authorized Users upload, publish, display, link to, or otherwise make available via the Services, and you agree that Swonkie is only acting as a passive conduit for the online distribution and publication of the Customer Content and the online display of Queries and Mentions. \n\n Swonkie has no obligation to preview, verify, check or delete any indecent, offensive and unlawful content. \n\n Every content posted by you is at your entire responsibility and Swonkie shall no be liable to you or any third party. \n\n You are responsible for the content that you upload, publish, display via Swonkie and you agree that Swonkie doesn’t have any control on the content published by you. \n\n As a Swonkie user you mus. \n\n i) Be responsible for your content and keep your personal data confidential, including your password; \n ii) Contact Swonkie if you detect any suspicious activity on your account; \n iii) Use the service only in accordance with the law and government regulations; \n\n As a Swonkie user you must not. \n\n i) Rent or sell your account service to a third party (or another person); \n ii) Upload or transmit any virus, by software or by link; \n iii) Use any deep link, page scrape, rebot, spider or other automatic program to copy our service or any ideias, features and functions; \n iv) Use the Service for any illegal purpose and violate, or encourage others to violate, any right of a third party, including by infringing or misappropriating any third party intellectual property right; \n v) Modify or create derivatives of any part of the Service; \n vi) Perform any fraudulent activity including impersonating any person or entity, claiming a false affiliation, accessing any other Service account without permission, or falsifying your age or date of Birth; \n\n Swonkie could suspend your access to our services if any conditions above or under are violated. \n\n Bear in mind that when you access the third party services you are at your own risk and these third parties services are governed by their own terms and conditions. Please read it carefully.'
                    ),
                },
                {
                    title: i18n.t('3. Rights'),
                    message: i18n.t(
                        'Swonkie keeps the right, at any time, announced previously or not, to shut down any feature, third party service or even shut down the platform service, if we decide to do so, without any user compensation or refund. \n\n In that case, if the user already bought a paid service or feature on our platform the user is not due any compensation from Swonkie. \n\n There Terms are effective beginning when you accept the Terms, register, login or access the service, and ending when the Subscription is over or cancelled by Swonkie. \n\n If you violate these Terms we can and or suspend your access to the service at any time with reason or no reason, with or without notice. \n\n Swonkie may also use customer content for some actions in terms of supporting and developing the platform. However, this content will be used anonymously. \n\n We reserve the right to refuse registration if our servers are full. \n In case of hacking or any action against a third party that cause any damage to you, loss or injury (resulting from hacking), Swonkie cannot be liable for that. \n Under no circumstances Swonkie is responsible for any damage, loss, injury that results from hacking. \n\n If any part of this agreement is or becomes illegal, invalid in any jurisdiction, the illegality or invalidity will not affect the legality and validity of this agreement (terms and conditions). \n\n By not respecting this terms and conditions the user can have their account deleted, with or without announcement, and will immediately cease all use of the services and have no further access to accounts provided by Swonkie.'
                    ),
                },
                {
                    title: i18n.t('4. Payment - Fees and Product Plans'),
                    message: i18n.t(
                        'Swonkie has several plans available. Our plans differ in their features and require the payment of a subscription as soon as the trial period ends, or whenever the license contracted for use expires. Before you pay any fees, you will have an opportunity to review and accept the fees that you will be charged. All fees are in Euros and are non-refundable.'
                    ),
                },
                {
                    title: i18n.t('4.1 Payment conditions'),
                    message: '',
                },
                {
                    title: i18n.t('4.1.1 Free Trial Period'),
                    message: i18n.t(
                        'If you sign up for a free trial period for a Service that is subject to charges (the “Free Trial”), we may require you to provide us with a valid credit card or other valid payment method. We may start charging you automatically on the first day after the Free Trial is over, unless you cancel it before the end of the Free Trial period. However if your Free Trial doesn’t require any credit card to subscribe your Trial, your Account will be suspended until be activated with a valid payment method. \n\n The free trial is only available to first time users of a paid online service and any suspicious activity of a multiple trial from the same user give to the Swonkie the right to ban the user forever.'
                    ),
                },
                {
                    title: i18n.t('4.1.2 Online Paid Services'),
                    message: i18n.t(
                        'For Paid Services purchased online (“Online Services”), you must provide a valid credit card or other payment method (e.g., PayPal account) to pay for such services. Some Services may be available as a one-time purchase, and others can be purchased as a monthly, quarterly, semiannually or yearly subscription. You agree that Swonkie has permission to retain and/or share with financial institutions and payment processing firms (including any institutions or firms Swonkie retains in the future) your submitted payment information in order to process your purchase. Depending on where you transact with us, the type of payment method used and where your payment method was issued, your transaction with us may be subject to foreign exchange fees or differences in prices, including because of exchange rates. Swonkie does not support all payment methods, currencies, or locations for payment. If the payment method you use with us, such as a credit card, reaches its expiration date and you do not edit your payment method information or cancel, you authorize Swonkie to continue billing your credit card and/or PayPal account and you remain responsible for any uncollected amounts. All applicable fees are calculated based on the billing information you provide us at the time of purchase.'
                    ),
                },
                {
                    title: i18n.t('4.1.3 Payment by Authorization Form'),
                    message: i18n.t(
                        'If an Authorization Form is issued for the purchase of Services, you agree to pay all fees as and when described per the Authorization Form(s). Swonkie shall invoice you for the fees in the currency set forth on the applicable Authorization Form. Unless otherwise stated on the Authorization Form, all invoices shall be payable within 30 days of the invoice date. Any disputed amounts shall not affect payment of non-disputed amounts. You shall make payments to the entity and address set forth in the invoice.'
                    ),
                },
                {
                    title: i18n.t(
                        '4.2 Subscrition Services, Cancellation Policy and Auto-Renewal'
                    ),
                    message: i18n.t(
                        'You may cancel the Subscription Service by accessing your account settings at. |swonkie.com/#/personal_settings/billing| or by mailing us at. |sayhello@swonkie.com| with the subject. Cancel my Subscription.'
                    ),
                },
                {
                    title: i18n.t('4.3 Refunds'),
                    message: i18n.t(
                        'Refundsare available when.\n\n i) If any changes on these terms and conditions impacts directly on you, and you have contracted and prepaid for a certain term, you may notify us within 30 days after being informed of that change that you do not agree with that. If you do so, we will refund any prepaid amount pro rata to you. If you use our services after your prepaid term ends, all changes will apply to you;\n\n Refundsare not available when.\n\nii) If at any time any supported Platforms cease to make their programs available to Swonkie on reasonable terms (each an \'API Change\'), Swonkie may cease to provide such features to you without entitling you to refund, credit, or other compensation;\niii) Subscriptions are billed in advance on a monthly, quarterly, semiannually or yearly basis and are non-refundable for the subscription period they are purchased for;\niv) Swonkie change, suspend or discontinue the service at any time. This suspension may include availability of any feature, database or content;'
                    ),
                },
                {
                    title: i18n.t('4.4 Amount Unpaid'),
                    message: i18n.t(
                        'If any amounts due hereunder are not received by Swonkie by the due date, Swonkie may suspend your access to the Services if Swonkie does not receive in 48 hours the amounts invoiced hereunder at the expiration of such period.'
                    ),
                },
                {
                    title: i18n.t('5. Warranty Disclaimer'),
                    message: i18n.t(
                        'The website was made to provide the best service to the user. The service and all materials and content available through the website are provided “as is” and on an “as available” basis.\n However we cannot guarantee and we disclaim any warranty of any kind, express or implied, including the warranties of merchantability, design, fitness for any purpose, title, quality that its services will meet your requirements or that its services will always be available, accessible, uninterrupted, timely, secure, accurate, complete or error-free.\nNeither Swonkie nor its suppliers and licensors give any warranty that the website will always work without any error, or access will be continuous or uninterrupted.\nWe disclaim any responsibility or liability in relation to the content that you download from our platform and the services provided by third parties.\nSwonkie does not control neither filter the customer content or mentions and is not responsible for their posts, images or shares through our platform.\nWe do not have any responsibility or liability for any third party or supported platform services, meaning that we are not responsible for any failure and problems with the connection to this third parties.\nSwonkie doesn’t cover any warranty for the interruption or cessation of access and transmission to/from our platform.\nSwonkie is not responsible or liable in any manner for any third-party services or supported platforms associated with or utilized in connection with the services, including the failure of any such third-party services or supported platforms.\nYou understand and agree that you use any portion of the service at your own discretion and risk, and that we are not responsible for any damage to your property, such as your computer system or mobile device used in connection with the service or any loss of data, including user content.\nSwonkie doesn’t have any responsibility resulting from hacking, tampering, or other unauthorized access or use of the services or your account or the information contained therein.'
                    ),
                },
                {
                    title: i18n.t('6. Indemnification'),
                    message: i18n.t(
                        'You are responsible for your use in Swonkie and you agree to indemnify and hold harmless Swonkie and its affiliates, contractors, licensors and their respective team, such as directors, officers and general employees, from and against any and all claims, expenses, losses and damages, including attorney’s fees in consequence of your website uses.'
                    ),
                },
                {
                    title: i18n.t('7. Limitation OF Liability'),
                    message: i18n.t(
                        'IN NO EVENT WILL THE SWONKIE ENTITIES BE LIABLE TO YOU FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES (INCLUDING DAMAGES FOR LOSS OF PROFITS, GOODWILL, OR ANY OTHER INTANGIBLE LOSS) ARISING OUT OF OR RELATING TO YOUR ACCESS TO OR USE OF, OR YOUR INABILITY TO ACCESS OR USE, THE SERVICE OR ANY MATERIALS OR CONTENT ON THE SERVICE, WHETHER BASED ON WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), STATUTE, OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT ANY SWONKIE ENTITY HAS BEEN INFORMED OF THE POSSIBILITY OF DAMAGE.'
                    ),
                },
                {
                    title: i18n.t('8. User\'s Obligation'),
                    message: i18n.t(
                        'You must guarantee that your use of our platform is done in accordance with our privacy policy (which we recommend to review together), with these terms and conditions and with all applicable laws and regulations. You also must ensure that you will respect the intellectual property rights of any third party.\nThis agreement doesn’t cover any partnership, joint venture, or employment relationship.'
                    ),
                },
                {
                    title: i18n.t('9. Copyright'),
                    message: i18n.t(
                        'All the content included in the website, such as images, graphics, button icons, text, logos and software, is the property of Swonkie or its suppliers and protected by Portugal’s and international copyright laws.'
                    ),
                },
                {
                    title: i18n.t('10. Third-party services'),
                    message: i18n.t(
                        'Sometimes when you use Swonkie, you may (as a result of or through your use of Swonkie) use a service or download a piece of software or purchase goods, which are provided by another person or company. Your use of these other services, software or goods may be subject to separate terms between you and the company or person concerned. If so, the Terms do not affect your legal relationship with these other companies or individuals and you remain responsible for complying with the terms of use of such third party’ services, software or goods. If you use third parties’ services, software or goods while using Swonkie, you declare that you act in compliance with their terms of use. In particular, if you use Facebook, Twitter or YouTube while using Swonkie, you must comply with the applicable Facebook (|https.//www.facebook.com/terms.php|), Twitter (|https.//twitter.com/en/tos|), YouTube (|https.//www.youtube.com/t/terms|) or Google (|https.//www.google.com/intl/en/policies/privacy/|) rules in versions effective as of the date of use of such services.'
                    ),
                },
                {
                    title: i18n.t('11. AI-Generated Content'),
                    message: i18n.t(
                        '11.1 Ownership and Responsibility\n11.1.1 The content generated by our AI model belongs to you, the user. You are solely responsible for the content you generate and publish using the app.\n11.1.2 We do not claim any ownership rights over the AI-generated content, and you retain all intellectual property rights associated with your content.\n\n11.2 Accuracy and Reliability\n11.2.1 While our AI model aims to provide accurate and reliable content, it may occasionally generate errors, inaccuracies, or inconsistencies.\n11.2.2 You acknowledge that the AI-generated content is a tool and should not be solely relied upon without human review and discretion. It is your responsibility to review and verify the accuracy, completeness, and suitability of the generated content before publishing.\n\n11.3 Compliance with Laws and Guidelines\n11.3.1 You are responsible for ensuring that the AI-generated content complies with all applicable laws, regulations, and guidelines, including but not limited to copyright, trademark, privacy, and data protection laws.\n11.3.2 You agree not to use the AI-generated content to engage in any illegal, unethical, or harmful activities, including but not limited to hate speech, harassment, or violation of third-party rights.\n\n11.4 Limitations and Disclaimers\n11.4.1 The AI-generated content is provided "as is" without any warranties or guarantees of accuracy, quality, or suitability.\n11.4.2 We disclaim any liability for damages, losses, or harm arising from the use or reliance on the AI-generated content or any actions taken based on such content.'
                    ),
                },
            ],
        },
        {
            title: i18n.t('Privacy Policy'),
            date: i18n.t('Last updated 10 July, 2023'),
            info: [
                {
                    title: i18n.t('1. Introduction'),
                    message: i18n.t(
                        'First of all, we’d like to say thank you for accessing our platform and for your interest in using it.\nWe aim to protect the privacy of all users who visit Swonkie’s platform on our website |swonkie.com|, which include all its subdomains.\nThis privacy policy was made to protect your privacy and personal data. By these terms we ensure our commitment to respect your privacy and to keep it safe.\nBy visiting us or using our platform you are consenting to the terms included in our present Privacy Policy, if you do not consent to the use of your Personal Information in these ways, please stop using the Services.'
                    ),
                },
                {
                    title: i18n.t('2. Our Privacy Policy'),
                    message: i18n.t(
                        'This Privacy Policy is about dealing with your personal data and all the information collected when you are using our platform and all the services we are providing you.\nHowever, it is important to emphasize that this Privacy Policy does not include the policies of any support services, such as Instagram, Facebook, Twitter, Google My Business, Youtube, Tumblr, Pinterest, WordPress, Tiktok or Linkedin either in the login processes or in any applications developed by third parties via API that Swonkie does not own or control.\nEvery content posted by these third parties that you can view on our platform via API, is not included in our Privacy Policy. We cannot take the responsibility for the content or privacy policies of any supported platforms or third parties apps, you must review carefully their own privacy policies.\nSwonkie reserves the right, at any time, to modify or replace the Privacy Policy. The most recent version of the Privacy Policy is available at |swonkie.com/privacy-policy|. Please check the Privacy Policy periodically for changes, though we will also notify you via email or other direct electronic communication methods of any changes that, in our sole discretion, materially impact your use of the Services or the treatment of your Personal Information. Your use of the Services following the posting of any changes to the Privacy Policy constitutes acceptance of those changes.'
                    ),
                },
                {
                    title: i18n.t('3. Information Collected'),
                    message: i18n.t(
                        'In the first contact with us, you will be required to become a registered user, following the steps of our process and submitting personal information.\nWe collect this information to provide you the best experience through our service, to communicate with you and to manage your registered account if you have one.\nThis will occur in the first contact, and we will collect information such as full name, email address, date of birth, gender, time zone, IP address, country, password and other optional information as part of your account profile.\nAlternatively, you may also register on a Swonkie account using API’s, such as Facebook or Google Plus.\n\nIn these two options, it will always be assigned a unique Swonkie user ID to your registration.\n\nWe collect some personal information about you such as.\n\ni) Your name, username, e-mail address, date of birth and other contact details;\nii) The location area where you are using swonkie from your computer or mobile devices;\niii) Your IP Address;\niv) Other information submitted by you or your organizational representatives via various methods (phone, email, online forms, surveys, in-person meetings, etc…);\nv) Your billing address and any necessary other information to complete any financial transaction, and when making purchases through the Services, we may also collect your credit card or PayPal information.\n\nSwonkie could automatically collects and receives certain information from your computer or mobile device, including the activities you perform on our Website, the Platforms, and the Applications, the type of hardware and software you are using (for example, your operating system or browser), and information obtained from cookies.\nFor example, each time you visit the Website or otherwise use the Services, we automatically collect your IP address, browser and device type, access times, the web page from which you came, the regions from which you navigate the web page, and the web page(s) you access (as applicable).'
                    ),
                },
                {
                    title: i18n.t('4. When we Collect Your Personal Data'),
                    message: i18n.t(
                        'We are colleting your personal data in different ways.\n\nRegistration. When you have the access for the first time to Swonkie, you will be required to become a registered user, and to do so, you need to submit the personal data to Swonkie, such as. Your name, username, e-mail address, date of birth, password and timezone.\n\nCustomer Support. To provide you a better service and help you with any doubt you can be requested to send any personal information or any content required to help you and provide you a better service.\n\nMaking a Purchase. When you are available to make a payment to acquire our service you will need to provide a personal information such as your credit card number and information needed and billing address.\n\nThird-Party Apps. To provide you the connection with social media platforms included on Swonkie and get all functionalities provided by us we may ask you to provide your username, account ids, social handle, timezones, e-mail address and other information needed to do the login on these services.\n\nOther data. We can get your personal details when you provide them in the context of our customer, vendor and partner relationships.\n\nAdditionaly swonkie could collect personal information from social media accounts when connected.\n\nThis information is needed to connect with Facebook, Twitter, Linkedin, Instagram, Google Plus, Pinterest, Tumblr, Wordpress, Blogspot and Medium.\n\nWe may collect information such as.\nProfile image\nDisplay name\nUsername / Page ID / profile ID\nAccess tokens\nSent posts\nContent of your posts\nEngagement Data (such as, Impressions, Reach, Engagement and general engagement information)\n\nBe aware that, all this information will only be used by Swonkie to provide you a better service or according with any condition on this policy.'
                    ),
                },
                {
                    title: i18n.t('5. How we Use Information'),
                    message: i18n.t(
                        'We may use your contact information to market to you, and provide you with information about, our products and services, including but not limited to our Service. If you decide at any time that you no longer wish to receive such information or communications from us, please un-follow us, or follow the unsubscribe instructions provided in any of the communications. You may also opt out from receiving commercial email from us switching off this option on your personal settings. Please be aware that if you opt out of receiving commercial email from us or otherwise modify the nature or frequency of promotional communications you receive from us, it may take up to ten business days for us to process your request, and you may continue receiving promotional communications from us during that period.\nBe aware that, even after you opt out from receiving commercial messages from us, you will continue to receive administrative messages from us regarding the Service.\n\nThe collected information is used to.\n\ni) To identify when you log in;\nii) To better understand your needs and the needs of users in the aggregate, diagnose problems, analyze trends, improve the features and usability of the Services, and better understand and market to our customers and users;\niii) To analyse the website and other services used when you are visiting/ using the platform;\niv) To contact you about your doubts and provide the required support;\nv) To share (non-identifiable) statistics and analytics data with our advertisers and partners;\nvi) To provide you all the information and news about our services;\nvii) To check your transactions and for purchase confirmation, billing, security and authentication which includes the security tokens for communication with installed third-party apps;\nviii) To analyze the Website or the other Services and information about our visitors and users, including research into our user demographics and user behaviour in order to improve our content and Services;\nix) To contact you about your account and provide customer service support, including responding to your comments and questions;\nx) To share aggregate (non-identifiable) statistics about users of the Services to prospective advertisers and partners;\nxi) To keep you informed about the Services, features, surveys, newsletters, offers, contests and events we think you may find useful or which you have requested from us;\nxii) To sell or market Swonkie products and services to you;\n\nWe also use non-identifiable information gathered for statistical purposes to keep track of the number of visits to the Services with a view to introducing improvements and improving usability of the Services. We may share this type of statistical data so that our partners also understand how often people use the Services, so that they, too, may provide you with an optimal experience.\n\nThe collected information is not used to.\n\ni) To get any identifiable content from your posts, messages, conversations and any information shared or created by any app (third parties) in our platform;\nii) To get any images or files that you publish in our platform via this third parties.'
                    ),
                },
                {
                    title: i18n.t('6. Log Data'),
                    message: i18n.t(
                        'When you visit our platform, our servers automatically save information that your browser sends when you access |swonkie.com|.\nWe will collect information such as your IP address, browser or device type to access the platform, the web pages you visit before and all the information that we need to improve your experience using our platform.'
                    ),
                },
                {
                    title: i18n.t('7. Cookies and Tracking Technology'),
                    message: i18n.t(
                        'Swonkie is using technology (known as “cookies”) to collect additional information to improve site and our service. We do not use cookies to collect personally identifiable information. Swonkie may use both session cookies and persistent cookies to better understand how you interact with the Site and our Service, to monitor aggregate usage by our users and web traffic routing on the Site, and to improve the Site and our services.\nPlease note that if you delete, or choose not to accept, cookies from the Service, you may not be able to utilize the features of the Service to their fullest potential.\nPartners who help us serve advertising on and off the Website and analytics companies may also put cookies on your device. We use several third-party vendors to help deliver ads for relevant Swonkie products and services to you when you visit certain pages on our Website and then visit certain third-party sites.\n\nSwonkie may also use other technologies such as web beacons, bugs, pixels or other software with the same aim. Additionally, we may implement third party buttons (such as the Facebook “share” button) that may function as web beacons even when you do not interact with the button. However this data collected through third-party web beacons and buttons is collected directly by these third parties, not by Swonkie.'
                    ),
                },
                {
                    title: i18n.t('8. Information That Can Be Shared'),
                    message: i18n.t(
                        'Our main aim for using your information is to publish your content on social platforms.\nThe information collected help us to know your performance on our platform, in order to provide you a better service.\n\nAll information gathered can be shared.\n\ni) If you agree with the share, as when you allow to be connected with a third party via our platform;\nii) If we are legally required to do that, such as in a legal process or in response to court orders, or to establish, protect and exercise our legal rights to defend us against legal claims or demands;\niii) When we believe it is necessary to investigate, prevent or take any action regarding illegal activities, fraud or situations involving any threats to us or our users;\niv) If we are acquired by or merged with another entity, where we need to transfer, sell or share all or part of the information collected on our platform, including your personally identifiable information;\nv) With certain third parties who provide services to us, such as hosting and maintenance, customer relationship, data storage and management, and marketing campaigns, being these third parties required to maintain the security of your data;\nvi) With a parent company, subsidiaries, joint ventures, or other companies under common control with Swonkie.'
                    ),
                },
                {
                    title: i18n.t('9. Changing or Deleting Information'),
                    message: i18n.t(
                        'If you already do your sign up in Swonkie you may access, update, correct, or delete the information you provided to us by e-mailing us at sayhello@swonkie.com. Be aware that while any changes you make will be reflected in active user databases within a reasonable period of time, we may retain all information you submit for backups, archiving, prevention of fraud and abuse, analytics, satisfaction of legal obligations, or where we otherwise reasonably believe that we have a legitimate reason to do so.\n\nIn certain jurisdictions you have the right to request access and receive information about the Personal Information we maintain about you, to update and correct inaccuracies in your Personal Information, to restrict or object to the processing of your Personal Information, to have the information blocked, anonymized or deleted, as appropriate, or to exercise your right to data portability to transfer your Personal Information to another company. Those rights may be limited in some circumstances by local law requirements. In addition to the above-mentioned rights, you also have the right to lodge a complaint with a competent supervisory authority subject to applicable law.\n\nYou mantain the right to.\n\n\n9.1 The right to access – this means that you have the right to request access to your personal data and to ask how your data is used by the us after it has been gathered. To do so, you can go to Profile settings and get your personal data, free to export.\n9.2 The right to be forgotten – if you are no longer using Swonkie, you can delete your Account and your personal data from Swonkie. Be aware that once you submitted this request your data will be permanently deleted and we will not be able to recover it.\n9.3 The right to have information corrected – this ensures that you can have your data updated if it is out of date or incomplete or incorrect. You can rectify most of your personal data from your Account Settings. For other personal data, you can request for rectification in writing at |sayhello@swonkie.com|.\n9.4 The right to object – this includes the right you have choose at any time to opt-in or opt-out of marketing email updates. We send email updates about product and feature announcements, promotions, educational materials, and events. Our updates focus on relevant information and never sell your data to marketing companies. You can manage this rule on your personal settings. However, be aware that, doing the Opt-out, this will not include all admin information.\n9.5 The right to be notified – If there has been a data breach which compromises your personal data, you have the right to be informed within 72 hours of first having become aware of the breach.\n\nGet more information about GDPR here.\n\nTo update your preferences, ask us to remove your information from our mailing lists, delete your account or submit a request to exercise your rights under applicable law, please contact us as specified in the “How to Contact Us” section below.'
                    ),
                },
                {
                    title: i18n.t('10. Connection to Other Websites'),
                    message: i18n.t(
                        'We contain links to other websites. However it is important to emphasize that this fact does not include from our part any representation or affiliation with that third party.\nWe do not have any control over third parties websites and their own cookies or any information gathered by them, so please read carefully their privacy policies or statements of the website you visit.\nWe are not responsible for the content, privacy and security practices, and policies of third party sites or services to which links or access are provided through the Service. We encourage you to read the privacy policies or statements of the other websites you visit.'
                    ),
                },
                {
                    title: i18n.t('11. Third-party services'),
                    message: i18n.t(
                        'Swonkie, integrates with various third-party services to enhance your experience and provide comprehensive social media management tools. By using our platform, you acknowledge and agree that Swonkie may access and process your data through the following integrated services:\n\nInstagram: |https://help.instagram.com/519522125107875?hl=en|\nFacebook: |https://www.facebook.com/about/privacy/|\nTwitter: |https://twitter.com/en/privacy|\nGoogle My Business: |https://policies.google.com/privacy?hl=en|\nYouTube: |https://www.youtube.com/t/terms|\nTumblr: |https://www.tumblr.com/privacy|\nPinterest: |https://policy.pinterest.com/pt-br/privacy-policy|\nWordPress: |https://wordpress.org/about/privacy/|\nTikTok: |https://www.tiktok.com/legal/privacy-policy?lang=en|\nLinkedIn: |https://www.linkedin.com/legal/privacy-policy?trk=homepage-basic_footer-privacy-policy|\nGoogle Drive: |https://policies.google.com/privacy?hl=en|\nSlack: |https://slack.com/intl/en-gb/trust/privacy/privacy-policy|\nPixabay: |https://pixabay.com/service/privacy/|\nRD Station: |https://ajuda.rdstation.com/s/article/Data-Privacy-Policy?language=en_US|\n\nPlease note that these third-party services have their own privacy policies, and we recommend reviewing them to understand how they collect, use, and disclose your personal information. Swonkie is not responsible for the privacy practices or content of these services.'
                    ),
                },
                {
                    title: i18n.t('12. AI-Generated Content and Privacy'),
                    message: i18n.t(
                        '12.1 Collection and Use of AI-Generated Content\n12.1.1 Swonkie may utilize AI technology to generate content based on user inputs or preferences.\n12.1.2 The AI-generated content may be collected and stored temporarily to facilitate the user experience within the app.\n12.1.3 We may use the AI-generated content to provide personalized recommendations, improve the app\'s functionality, and enhance the quality of the content generated.\n\n12.2 Data Security and Confidentiality\n12.2.1 We implement reasonable security measures to protect the AI-generated content from unauthorized access, disclosure, or alteration.\n12.2.2 We maintain strict confidentiality regarding the AI-generated content and will not share or sell it to third parties without your explicit consent, unless required by law or as necessary for the provision of our services.\n\n12.3 Data Retention\n12.3.1 We retain the AI-generated content for a limited period necessary to fulfill the purposes outlined in this privacy policy.\n12.3.2 Upon your request or termination of your account, we will delete or anonymize the AI-generated content, unless retention is required by law or legitimate business purposes.\n\n12.4 User Control and Consent\n12.4.1 By using the social media publishing app and generating AI-generated content, you consent to the collection, use, and processing of such content as described in this privacy policy.\n12.4.2 You have the right to access, modify, or delete the AI-generated content associated with your account. You can exercise these rights by contacting us through the provided channels.\n\n12.5 Legal Compliance\n12.5.1 We comply with applicable privacy laws and regulations regarding the collection, use, and processing of personal data, including AI-generated content.\n12.5.2 We may disclose AI-generated content if required by law or when necessary to protect our rights, safety, or the rights and safety of others.'
                    ),
                },
                {
                    title: i18n.t('13. Our Policy With Children'),
                    message: i18n.t(
                        'Our platform established a minimum age to access our services, which are not intended to be used by children or anyone else under 13 years old.\n\nHowever there are some exceptions.\ni) if a different minimum age is allowed by any API (third party) supported by our platform;\nii) if we are legally required to do so.\n\nIf a parent or guardian becomes aware that their child (under 13) is using our service, they should contact us on |sayhello@swonkie.com|.'
                    ),
                },
                {
                    title: i18n.t('14. Security'),
                    message: i18n.t(
                        'Swonkie is very concerned about safeguarding the confidentiality of your personally identifiable information. We employ all efforts to protect all confidential content from unauthorized access, however you should bear in mind that submission of information over the Internet is never entirely secure.\nOur data is encrypted in order to provide you a safer service.\nWe cannot and do not guarantee that information about you will not be accessed, viewed, disclosed, altered, or destroyed by breach of any of our administrative, physical, and electronic safeguards.\nYou should bear in mind that submission of information over the Internet is never entirely secure.\nIf you are a Logged-in User, it is advisable that you log out of your account at the end of every session and not leave a logged-in account unattended for any period of time, particularly if you use a shared computer or device.'
                    ),
                },
                {
                    title: i18n.t('15. Changes to This policy'),
                    message: i18n.t(
                        'We can update this Policy at any point, for any reason and modify /replace this policy when considered appropriate.\nThe most recent version will be available on our platform at |swonkie.com/privacy-policy|.\nYou will be notified if this Policy suffer any alteration.'
                    ),
                },
                {
                    title: i18n.t('16. How to Contact Us'),
                    message: i18n.t(
                        'If you have questions or need to contact us about this Privacy Policy, please email us at |sayhello@swonkie.com|.'
                    ),
                },
            ],
        },
        {
            title: i18n.t('GDPR'),
            date: i18n.t('Last updated 24 May, 2018'),
            info: [
                {
                    title: i18n.t('GDPR COMPLIANCE'),
                    message: i18n.t(
                        'Swonkie is committed to our users’ rights to privacy. Our aim is to share all the ways Swonkie products and website work regarding privacy, terms, and personal data, and we are in full support of efforts to ensure your online protection.\n\n The EU’s General Data Protection Regulations (GDPR) take effect May 25, and we are fully committed to ensure our customers’ data is secure.'
                    ),
                },
                {
                    title: i18n.t('WHAT IS GDPR?'),
                    message: i18n.t(
                        'On May 25, 2018, a new European privacy regulation called The General Data Protection Regulation (GDPR) will come into effect. \n\n GDPR is a new set of rules designed to give EU citizens more control over their personal data. \n\n This regulation will be implemented in all local privacy laws across the entire EU and EEA region. It will apply to all companies selling to and storing personal information about citizens in Europe, including companies on other continents. It provides citizens of the EU and EEA with greater control over their personal data and assurances that their information is being securely protected across Europe.'
                    ),
                },
                {
                    title: i18n.t('WHO DOES GDPR APPLY TO?'),
                    message: i18n.t(
                        'The GDPR applies to EU based companies and those that collect data of EU citizens, regardless of a physical presence in the EU. \n\n The GDPR is the EU’s way of giving individuals, prospects, customers, contractors and employees more power over their data and less power to the organizations that collect and use such data for monetary gain.'
                    ),
                },
                {
                    title: i18n.t(
                        'WHAT’S USERS’ RIGHTS UNDER GDPR COMPLIANCE?'
                    ),
                    message: i18n.t(
                        '1. The right to access – this means that you have the right to request access to your personal data and to ask how your data is used by us after it has been gathered. To do so, you can go to Profile settings and get your personal data, free to export.\n\n 2. The right to be forgotten – if you are no longer using Swonkie, you can delete your Account and your personal data from Swonkie. Be aware that once you submitted this request your data will be permanently deleted and we will not be able to recover it. \n\n 3. The right to have information corrected – this ensures that you can have your data updated if it is out of date or incomplete or incorrect. You can rectify most of your personal data from your Account Settings. For other personal data, you can request for rectification in writing at |sayhello@swonkie.com|. \n\n 4. The right to object – this includes the right you have choose at any time to opt-in or opt-out of marketing e-mail updates. We send e-mail updates about product and feature announcements, promotions, educational materials, and events. Our updates focus on relevant information and never sell your data to marketing companies. You can manage this rule on your personal settings. However, be aware that, doing the Opt-out, this will not include all administration information. \n\n 5. The right to be notified – If there has been a data breach which compromises your personal data, you have the right to be informed within 72 hours as soon as we become aware of the breach. \n\n We are very committed to ensure that all this turned our relation clearer. However, feel free to e-mail us via |sayhello@swonkie.com| or chat with us (right bottom corner) if any doubt persists. We are just here to help you and, to make your social media activity better, this is what really matters to us. \n\n'
                    ),
                },
            ],
        },
        {
            title: i18n.t('Security'),
            date: i18n.t('Last updated 24 May, 2018'),
            info: [
                {
                    title: i18n.t('1. Security'),
                    message: i18n.t(
                        'Swonkie is very concerned about safeguarding the confidentiality of your personally identifiable information. We employ all efforts to protect all confidential content from unauthorized access, however you should bear in mind that submission of information over the Internet is never entirely secure.\nOur data is encrypted in order to provide you a safer service.\nWe cannot and do not guarantee that information about you will not be accessed, viewed, disclosed, altered, or destroyed by breach of any of our administrative, physical, and electronic safeguards.\nYou should bear in mind that submission of information over the Internet is never entirely secure.\nIf you are a Logged-in User, it is advisable that you log out of your account at the end of every session and not leave a logged-in account unattended for any period of time, particularly if you use a shared computer or device.'
                    ),
                },
            ],
        },
    ],
};

export default DataArray;
